import { CodeNode as Ft, CodeHighlightNode as Mt } from "@lexical/code";
import { HashtagNode as Nt } from "@lexical/hashtag";
import { AutoLinkNode as Dt, LinkNode as Et } from "@lexical/link";
import { ListNode as Ot, ListItemNode as St } from "@lexical/list";
import { OverflowNode as Tt } from "@lexical/overflow";
import { HorizontalRuleNode as kt } from "@lexical/react/LexicalHorizontalRuleNode";
import { HeadingNode as At, QuoteNode as Pt } from "@lexical/rich-text";
import { TableNode as It, TableCellNode as Lt, TableRowNode as Rt } from "@lexical/table";
import { TextNode as Pe, $applyNodeReplacement as Y, ElementNode as Q, createCommand as Ve, $isNodeSelection as Yt, $getSelection as Bt, $getNodeByKey as Ye, CLICK_COMMAND as Ht, COMMAND_PRIORITY_LOW as Oe, KEY_DELETE_COMMAND as $t, KEY_BACKSPACE_COMMAND as zt, DecoratorNode as Z, $isElementNode as Wt, $createParagraphNode as Be, createEditor as Jt } from "lexical";
import { jsx as i, jsxs as f, Fragment as A } from "react/jsx-runtime";
import { useLexicalComposerContext as Vt } from "@lexical/react/LexicalComposerContext";
import { useLexicalNodeSelection as Kt } from "@lexical/react/useLexicalNodeSelection";
import { mergeRegister as qt } from "@lexical/utils";
import * as Ke from "react";
import x, { useState as jt, useEffect as ue, useCallback as Se, Suspense as qe } from "react";
import { styled as D, TextField as Ut, alpha as T, Popover as Gt, Button as pe, Box as N, Accordion as ye, AccordionSummary as W, AccordionDetails as J, FormControl as M, Typography as g, MenuItem as _e, Fade as R, RadioGroup as je, FormControlLabel as he, Divider as ve } from "@mui/material";
import Xt from "@mui/icons-material/AccountTreeRounded";
import Qt from "@mui/icons-material/StickyNote2Rounded";
import fe from "clsx";
import { BlockWithAlignableContents as Ue } from "@lexical/react/LexicalBlockWithAlignableContents";
import { DecoratorBlockNode as Ge } from "@lexical/react/LexicalDecoratorBlockNode";
import Ie from "@mui/icons-material/CheckCircleOutlineRounded";
import V from "@mui/icons-material/ExpandMoreRounded";
import { addMonths as de, startOfDay as Te, differenceInMonths as Zt } from "date-fns";
import { isNaN as me } from "lodash";
import { DesktopDatePicker as en } from "@mui/x-date-pickers";
import { AdapterDateFns as tn } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider as nn } from "@mui/x-date-pickers/LocalizationProvider";
import rn from "@mui/material/Radio";
import { styled as Xe } from "@mui/material/styles";
import { orange as He } from "@mui/material/colors";
const b = {
  100: "#F3F4F6",
  // A hairline between 100 and 300. The gap between them is wide enough that a
  // 1px rule wants 100 (invisible) or 300 (a hard edge) with nothing in between,
  // so every divider inside a panel or a list row lands here.
  200: "#E3E7ED",
  300: "#D0D5DC",
  400: "#728096",
  // Secondary body text: readable at 13px on white, which 400 is not quite, while
  // 500 is the full ink used for primary text. Sits between them for the same
  // reason 200 sits between 100 and 300.
  450: "#4B5B73",
  500: "#142B50",
  600: "#102240",
  700: "#0C1A30",
  800: "#040910"
}, y = {
  100: "#F2F7FF",
  300: "#CCE0FF",
  400: "#66A1FF",
  500: "#0062FF",
  600: "#004ECC",
  700: "#003B99",
  800: "#001433"
}, E = {
  100: "#FFFBF2",
  200: "#FFEECC",
  300: "#FFEECC",
  400: "#FFCD66",
  500: "#FFAB00",
  600: "#CC8900",
  700: "#996700",
  800: "#332200"
}, I = {
  100: "#FFF2F6",
  200: "#FFCCDB",
  300: "#FFCCDB",
  400: "#FF6694",
  500: "#FF004D",
  600: "#CC003D",
  700: "#99002E",
  800: "#33000F"
}, F = {
  100: "#F4FDF7",
  300: "#D4F9DE",
  400: "#7EEE9D",
  500: "#28E25C",
  600: "#20B549",
  700: "#188837",
  800: "#082D12"
}, ke = {
  100: "#FFFDFC",
  200: "#FFFAF9",
  300: "#FFEBE8",
  400: "#FFC2BB",
  500: "#FF9A8D",
  550: "#CF7A6D",
  600: "#995C55",
  700: "#331F1C",
  800: "#0D0807"
}, Oo = {
  background: "#FDECEC",
  border: "#F0A6A6",
  foreground: "#B42318"
}, So = {
  background: "#FFF4D6",
  border: "#F5C542",
  foreground: "#8A5A00"
}, To = {
  background: "#E8F5E9",
  border: "#A5D6A7",
  foreground: "#2E7D32"
}, ko = {
  positive: "#5AB55E",
  negative: "#E5484D",
  track: "#E3E7ED"
}, Ao = {
  background: E[100],
  border: E[200],
  foreground: E[500]
}, Po = {
  background: b[100],
  border: b[300],
  foreground: b[400]
}, Io = {
  background: ke[300],
  border: ke[400],
  foreground: ke[550]
}, Lo = {
  background: y[100],
  border: y[300],
  foreground: y[400]
}, Ro = {
  100: "#FFFDFB",
  200: "#FEFAF6",
  300: "#FDEDDA",
  400: "#F9C991",
  500: "#F4A547",
  600: "#93632B",
  700: "#31210E",
  800: "#0C0804"
}, $e = {
  100: "#FAF7FF",
  200: "#F6F0FF",
  300: "#ECE0FF",
  400: "#C6A3FF",
  500: "#A066FF",
  600: "#603D99",
  700: "#201433",
  800: "#100A19"
}, Yo = {
  100: "#F8FDFE",
  200: "#F3FBFD",
  300: "#E7F3F7",
  400: "#B8DCE8",
  500: "#89C5D8",
  600: "#527682",
  700: "#1B272B",
  800: "#0E1416"
}, Bo = {
  100: "#F8FCFE",
  200: "#F2FBFE",
  300: "#E3F5FB",
  400: "#ADE2F3",
  500: "#76CFEB",
  600: "#477C8D",
  700: "#17292F",
  800: "#0C1518"
}, Qe = Xe("span")(({ theme: t }) => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow: t.palette.mode === "dark" ? "0 0 0 1px rgb(16 22 26 / 40%)" : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  backgroundColor: t.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
  backgroundImage: t.palette.mode === "dark" ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))" : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: `2px auto ${y[700]}`,
    outlineOffset: 2
  },
  "input:hover ~ &": {
    backgroundColor: t.palette.mode === "dark" ? "#30404d" : "#ebf1f5"
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: t.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)"
  }
})), on = Xe(Qe)({
  backgroundColor: y[500],
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""'
  },
  "input:hover ~ &": {
    backgroundColor: y[600]
  }
});
function ge(t) {
  return /* @__PURE__ */ i(
    rn,
    {
      disableRipple: !0,
      color: "default",
      checkedIcon: /* @__PURE__ */ i(on, {}),
      icon: /* @__PURE__ */ i(Qe, {}),
      ...t
    }
  );
}
const an = D(Ut)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
      "&::placeholder": {
        color: b[400]
      }
    }
  },
  backgroundColor: T(b[100], 0.5),
  borderRadius: 4,
  color: b[800],
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    opacity: 0.5,
    color: b[400]
  },
  "&:hover": {
    backgroundColor: b[100]
  }
});
function k(t) {
  return /* @__PURE__ */ i(an, { ...t });
}
function Ze(t) {
  return /* @__PURE__ */ i(nn, { dateAdapter: tn, children: /* @__PURE__ */ i(
    en,
    {
      ...t,
      enableAccessibleFieldDOMStructure: !1,
      slots: { textField: k }
    }
  ) });
}
const U = "search-context", sn = T(E[300], 0.7), ln = `background-color: ${sn}`;
function cn(t) {
  return `${t === "" ? "" : `${t};`}${ln}`;
}
class Ce extends Pe {
  __className;
  static getType() {
    return U;
  }
  static clone(e) {
    return new Ce(e.__className, e.__text, e.__key);
  }
  constructor(e, n, r) {
    super(n, r), this.__className = e;
  }
  static importJSON(e) {
    const n = un(
      e.className,
      e.text
    );
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(cn(e.style)), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      className: this.getClassName(),
      type: U
    };
  }
  getClassName() {
    return this.getLatest().__className;
  }
}
function un(t, e) {
  const n = new Ce(t, e).setMode("token");
  return Y(n);
}
const G = "search-match", dn = E[400], mn = `background-color: ${dn}`;
function pn(t) {
  return `${t === "" ? "" : `${t};`}${mn}`;
}
class we extends Pe {
  __className;
  static getType() {
    return G;
  }
  static clone(e) {
    return new we(e.__className, e.__text, e.__key);
  }
  constructor(e, n, r) {
    super(n, r), this.__className = e;
  }
  static importJSON(e) {
    const n = hn(
      e.className,
      e.text
    );
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(pn(e.style)), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      className: this.getClassName(),
      type: G
    };
  }
  getClassName() {
    return this.getLatest().__className;
  }
}
function hn(t, e) {
  const n = new we(t, e).setMode("token");
  return Y(n);
}
function et(t, e, n) {
  const r = t.map((o, a) => a === t.length - 1 ? [o] : [
    o,
    {
      start: o.end,
      matchLevel: n,
      end: t[a + 1].start
    }
  ]).flat();
  return r.unshift({ matchLevel: n, start: 0, end: t[0].start }), r.push({ matchLevel: n, start: t[t.length - 1].end, end: e }), r.filter((o) => o.end > o.start);
}
const fn = /<strong>(.*?)<\/strong>/gi;
function gn(t) {
  const e = [...t.matchAll(fn)];
  if (!e.length)
    return console.error("No match found. This should never happen."), [];
  let n = 0;
  const r = e.map((a) => {
    const s = a.index - n, l = {
      start: s,
      end: s + a[1].length,
      matchLevel: "match"
    };
    return n += a[0].length - a[1].length, l;
  }), o = t.length - n;
  return et(r, o, "context");
}
function bn(t, e) {
  return t.length < 3 ? t : t.reduce((n, r) => {
    if (n.length < 2) return [...n, r];
    const [o, a, ...s] = n.reverse();
    return n.reverse(), r.matchLevel === "match" && o.matchLevel !== null && o.end - o.start === 1 && e.substring(o.start, o.end) === " " && a.matchLevel === "match" ? [{ start: a.start, end: r.end, matchLevel: "match" }, ...s].reverse() : [...n, r];
  }, []);
}
function xn(t, e, n) {
  const r = gn(n);
  if (!r.length) return [];
  const o = t.flatMap((s) => r.map(((l) => ({
    ...l,
    start: s + l.start,
    end: s + l.end
  })))), a = et(o, e.length, null);
  return bn(a, e);
}
function be(t) {
  return t.type === "text";
}
function yn(t, e) {
  return !["text", U, G].includes(t) || e === null ? t : t === "search-match" ? G : e === "context" ? U : "search-match";
}
function P(t, e) {
  if (!t.length) return [[], e];
  if (!e.length) throw new Error("Invalid state while splitting text nodes according to indices. Indices is empty.");
  const [n, ...r] = t;
  if (!be(n)) {
    const h = n;
    if (!h?.children?.find((H) => be(H))) {
      const [H, Ee] = P(r, e);
      return [[n, ...H], Ee];
    }
    const [v, q] = P(h.children, e), S = {
      ...h,
      children: v
    }, [j, B] = P(r, q);
    return [[S, ...j], B];
  }
  const [o, a] = e, s = a ? a.start : n.text.length + 1, l = Math.min(s, n.text.length), c = {
    ...n,
    text: n.text.substring(0, l),
    type: yn(n.type, o.matchLevel)
  }, m = e.map((h) => ({ ...h, start: Math.max(h.start - l, 0) }));
  if (s === n.text.length) {
    const [h, w] = P(r, m.slice(1));
    return [[c, ...h], w];
  }
  if (s > n.text.length) {
    const [h, w] = P(r, m);
    return [[c, ...h], w];
  }
  const u = { ...n, text: n.text.substring(l) }, [p, d] = P([u, ...r], m.slice(1));
  return [[c, ...p], d];
}
function _n(t, e) {
  const [n] = P(t, e);
  return n;
}
function tt(t, e) {
  const n = t.indexOf(e);
  return n === -1 ? [] : [
    n,
    ...tt(t.slice(n + e.length), e)
  ];
}
function nt(t, e) {
  if (!t.children) return t;
  if (!t.children.find((a) => ["link", "text", U, G].includes(a.type)))
    return {
      ...t,
      children: t.children.map((a) => nt(a, e))
    };
  const n = t.children.flatMap((a) => {
    if (be(a)) return [a.text];
    const s = a;
    return s?.children?.length ? s.children.flatMap((c) => be(c) ? [c.text] : []) : [];
  }).join(""), r = tt(n, e.replaceAll("<strong>", "").replaceAll("</strong>", ""));
  if (!r.length) return t;
  const o = xn(r, n, e);
  return o.length ? {
    ...t,
    children: _n(t.children, o)
  } : t;
}
function Ho(t, e) {
  if (!e) return t;
  const n = JSON.parse(t), r = e.reduce((o, a) => nt(o, a), n.root);
  return JSON.stringify({
    root: r
  });
}
function vn(t) {
  return {
    node: rt()
  };
}
class Fe extends Q {
  __classes;
  constructor(e, n) {
    super(n), this.__classes = e ?? [];
  }
  static getType() {
    return "block";
  }
  static clone(e) {
    return new Fe(e.__classes, e.__key);
  }
  createDOM(e, n) {
    const r = document.createElement("div");
    return r.classList.add("Block"), this.__classes.forEach((o) => {
      r.classList.add(o);
    }), r;
  }
  static importDOM() {
    return {
      div: (e) => ({
        conversion: vn,
        priority: 1
      })
    };
  }
  static importJSON(e) {
    return rt(e.classes);
  }
  exportDOM() {
    return { element: document.createElement("div") };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      classes: this.__classes?.length ? this.__classes : void 0,
      type: "block",
      version: 1
    };
  }
}
function rt(t) {
  return new Fe(t);
}
const Ae = {
  links: { card: "Card", decisionTree: "Decision tree", document: "Document" },
  linkEditor: { edit: "Edit link", open: "Open link", unlink: "Remove link" },
  linkChip: {
    changeTarget: "Change target",
    remove: "Remove",
    badges: { tabDeleted: "Tab deleted", targetNotFound: "Target not found", unauthorized: "Unauthorized" }
  },
  refresh: "Refresh",
  transparent: "Transparent",
  clear: "Clear",
  imageOpenInNewTab: "Open image in new tab",
  table: {
    addColumnHeader: "Add column header",
    addRowHeader: "Add row header",
    deleteColumn: "Delete column",
    deleteRow: "Delete row",
    deleteTable: "Delete table",
    insertColumnLeft: (t) => `Insert ${t} column(s) left`,
    insertColumnRight: (t) => `Insert ${t} column(s) right`,
    insertRowAbove: (t) => `Insert ${t} row(s) above`,
    insertRowBelow: (t) => `Insert ${t} row(s) below`,
    mergeCells: "Merge cells",
    removeColumnHeader: "Remove column header",
    removeRowHeader: "Remove row header",
    unmergeCells: "Unmerge cells"
  },
  formula: {
    cta: "Termination fee calculator",
    title: "Termination fees",
    next: "Next",
    contract: {
      title: "Current contract",
      deviceTitle: "Device",
      box: "Box",
      mobile: "Mobile",
      operatorTitle: "Operator",
      operatorPlaceholder: "Operator"
    },
    commitment: {
      title: "Commitment",
      initialTitle: "Initial commitment",
      initialPlaceholder: "Months",
      initialOption: (t) => t === "0" ? "No commitment" : `${t} months`,
      endTitle: "End of commitment",
      hasEquipmentTitle: "Equipment to return",
      hasEquipmentDescription: "Equipment not returned is charged",
      hasEquipmentTrue: "Yes",
      hasEquipmentFalse: "No"
    },
    price: {
      title: "Price",
      priceTitle: "Monthly price",
      promotionPrice: "Promotional price",
      promotionDuration: "Promotion duration",
      promotionStart: "Promotion start",
      promotionPlaceholder: "Amount"
    },
    offer: { offerTitle: "Offer", customizeTitle: "Customise" }
  }
}, Cn = { strings: Ae }, ot = x.createContext(Cn);
function wn(t) {
  if (!t) return Ae;
  const e = { ...Ae };
  return Object.entries(t).forEach(([n, r]) => {
    const o = e[n];
    if (r && typeof r == "object" && o && typeof o == "object") {
      e[n] = { ...o, ...r };
      return;
    }
    r !== void 0 && (e[n] = r);
  }), e;
}
function $o({ children: t, strings: e, ...n }) {
  const r = x.useMemo(
    () => ({ ...n, strings: wn(e) }),
    [e, ...Object.values(n)]
  );
  return /* @__PURE__ */ i(ot.Provider, { value: r, children: t });
}
function C() {
  return x.useContext(ot);
}
const Fn = D(Gt)({
  pointerEvents: "none",
  "& .MuiPaper-root": {
    pointerEvents: "auto"
  }
}), Mn = D(Fn)({
  "& .MuiPaper-root": {
    background: "#fff",
    border: `1px solid ${b[100]}`,
    borderRadius: 6,
    padding: 4,
    display: "flex",
    alignItems: "center",
    gap: 2,
    boxShadow: "0 6px 16px rgba(4,9,16,.12)"
  },
  "& .MuiButton-root": {
    // Longhand, not `font: '600 12px/1 inherit'`: `inherit` is not a valid font-family token
    // inside the shorthand, so that declaration was silently dropped and this button rendered
    // at MUI's default (larger) button text size instead.
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1,
    color: b[500],
    padding: "6px 9px",
    borderRadius: 4,
    minWidth: "unset",
    "&:hover": {
      background: b[100]
    }
  },
  "& .MuiButton-root.remove": {
    color: I[600]
  },
  "& .divider": {
    width: 1,
    height: 14,
    background: b[100]
  }
});
function Nn({
  anchorEl: t,
  changeTargetLabel: e,
  removeLabel: n,
  onChangeTarget: r,
  onRemove: o
}) {
  return /* @__PURE__ */ f(
    Mn,
    {
      anchorEl: t,
      open: !!t,
      keepMounted: !0,
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      transformOrigin: { vertical: -4, horizontal: "left" },
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      elevation: 0,
      children: [
        /* @__PURE__ */ i(pe, { type: "button", onClick: r, children: e }),
        /* @__PURE__ */ i("span", { className: "divider" }),
        /* @__PURE__ */ i(pe, { type: "button", className: "remove", onClick: o, children: n })
      ]
    }
  );
}
const Dn = Ve(), En = Ve(), ze = D(N)({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  borderRadius: 6,
  padding: "3px 10px 3px 7px",
  border: "1px solid transparent",
  verticalAlign: "middle",
  maxWidth: "100%",
  boxSizing: "border-box",
  "&.twoSegment": {
    padding: "3px 4px 3px 7px"
  },
  "& svg": {
    fontSize: 14,
    display: "block",
    flexShrink: 0
  },
  "& .title": {
    fontWeight: 600,
    fontSize: 15,
    lineHeight: 1.3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  "& .chevron": {
    color: y[400],
    flexShrink: 0
  },
  "& .tab": {
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 1.3,
    color: b[500],
    background: "#fff",
    borderRadius: 4,
    padding: "2px 7px",
    maxWidth: 110,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  "& .badge": {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 1,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    flexShrink: 0
  },
  // Fixed widths so the real title/tab replacing them never shifts surrounding text -- no
  // measured layout shift is the point, not just "close enough".
  "& .title-ghost": {
    display: "block",
    width: 104,
    height: 10,
    borderRadius: 3,
    background: b[300]
  },
  "& .tab-ghost": {
    display: "block",
    width: 52,
    height: 14,
    borderRadius: 3,
    background: "#fff"
  },
  // Card / tree only pick the frame color -- the icon and title inherit `color` from the box
  // itself, so an error state (below) only has to override this one property to recolor both.
  "&.card": {
    background: y[100],
    borderColor: y[300],
    color: y[700]
  },
  "&.card svg": { color: y[500] },
  "&.tree": {
    background: F[100],
    borderColor: F[300],
    color: F[700]
  },
  "&.tree svg": { color: F[600] },
  "&.clickable": { cursor: "pointer" },
  "&.card.clickable:hover": { borderColor: y[400] },
  "&.tree.clickable:hover": { borderColor: F[400] },
  // Write mode: an atomic, non-editable node -- dashed even before it is selected, solid only
  // for the read-mode chip a viewer can click through to open.
  "&.editable": { borderStyle: "dashed" },
  "&.editable.card": { borderColor: y[400] },
  "&.editable.tree": { borderColor: F[400] },
  "&.editable.selected.card": { background: y[300], borderColor: y[500] },
  "&.editable.selected.tree": { background: F[300], borderColor: F[600] },
  // Error states override the card/tree palette outright -- the type icon stays, but the frame
  // reports the problem instead of the target.
  "&.error-tab-deleted": {
    background: E[100],
    borderColor: E[200],
    color: E[700]
  },
  "&.error-tab-deleted svg": { color: E[700] },
  "&.error-target-not-found": {
    background: I[100],
    borderColor: I[200],
    color: I[700]
  },
  "&.error-target-not-found svg": { color: I[500] },
  "&.error-target-not-found .title": { textDecoration: "line-through" },
  "&.error-unauthorized": {
    background: b[100],
    borderColor: b[300],
    color: b[400]
  },
  "&.error-unauthorized svg": { color: b[400] },
  // Same frame, same border, only the icon dims and the content ghosts -- no spinner, no
  // gradient shimmer. `prefers-reduced-motion` gets a static (non-pulsing) ghost instead of
  // turning the animation into something jarring at 0 duration.
  "&.loading.card svg": { color: y[300] },
  "&.loading.tree svg": { color: F[300] },
  "&.loading": {
    cursor: "default",
    animation: "linkChipGhostPulse 1.4s ease-in-out infinite"
  },
  "@keyframes linkChipGhostPulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.45 },
    "100%": { opacity: 1 }
  },
  "@media (prefers-reduced-motion: reduce)": {
    "&.loading": { animation: "none" }
  }
}), On = {
  card: Qt,
  tree: Xt
}, Sn = (t, e) => {
  if (t)
    return {
      "tab-deleted": t.tabDeleted,
      "target-not-found": t.targetNotFound,
      unauthorized: t.unauthorized
    }[e];
};
function Tn({
  variant: t,
  title: e,
  tab: n,
  errorState: r,
  badges: o,
  loading: a,
  readOnly: s,
  selected: l,
  onClick: c,
  className: m
}) {
  const u = On[t];
  if (a)
    return /* @__PURE__ */ f(ze, { className: fe(m, t, "loading", { editable: !s, twoSegment: !!n }), children: [
      /* @__PURE__ */ i(u, {}),
      /* @__PURE__ */ i("span", { className: "title-ghost" }),
      n && /* @__PURE__ */ f(A, { children: [
        /* @__PURE__ */ i("span", { className: "chevron", children: "›" }),
        /* @__PURE__ */ i("span", { className: "tab-ghost" })
      ] })
    ] });
  const p = !!n && !r, d = !!c && !r;
  return /* @__PURE__ */ f(
    ze,
    {
      className: fe(m, t, r && `error-${r}`, {
        editable: !s,
        selected: l && !s,
        twoSegment: p,
        clickable: d
      }),
      onClick: d ? c : void 0,
      role: d ? "button" : void 0,
      tabIndex: d ? 0 : void 0,
      children: [
        /* @__PURE__ */ i(u, {}),
        /* @__PURE__ */ i("span", { className: "title", children: e }),
        p && n && /* @__PURE__ */ f(A, { children: [
          /* @__PURE__ */ i("span", { className: "chevron", children: "›" }),
          /* @__PURE__ */ i("span", { className: "tab", title: n.title, children: n.title })
        ] }),
        r && /* @__PURE__ */ i("span", { className: "badge", children: Sn(o, r) })
      ]
    }
  );
}
function kn(t, e, n) {
  const [r, o] = jt(null);
  return ue(() => {
    if (!n) {
      o(null);
      return;
    }
    o(t.getElementByKey(e));
  }, [t, e, n]), r;
}
function it({
  variant: t,
  nodeKey: e,
  id: n,
  tabId: r
}) {
  const [o] = Vt(), {
    strings: a,
    renderCardLink: s,
    renderDecisionTreeLink: l,
    onCardLinkOpen: c,
    onDecisionTreeLinkOpen: m
  } = C(), [u, p, d] = Kt(e), [h, w] = x.useState(() => !o.isEditable());
  ue(() => o.registerEditableListener(($) => {
    w(!$);
  }), [o]);
  const v = Se(($) => (u && Yt(Bt()) && ($.preventDefault(), Ye(e)?.remove(), p(!1)), !1), [u, e, p]), q = Se(() => {
    t === "card" ? c?.(n, r) : m?.(n);
  }, [t, n, r, c, m]), S = Se(() => {
    d(), p(!0);
  }, [d, p]);
  ue(() => {
    if (!h)
      return o.registerCommand(
        Ht,
        ($) => {
          const Re = o.getElementByKey(e);
          return !Re || !($.target instanceof Node) || !Re.contains($.target) ? !1 : (S(), !0);
        },
        Oe
      );
  }, [o, e, h, S]), ue(() => qt(
    o.registerCommand($t, v, Oe),
    o.registerCommand(zt, v, Oe)
  ), [o, v]);
  const j = t === "card" ? !!c : !!m;
  let B;
  h ? B = j ? q : void 0 : B = S;
  const H = { readOnly: h, selected: u, onClick: B }, Ee = t === "card" ? s?.(n, r, H) : l?.(n, H), wt = kn(o, e, u && !h);
  return /* @__PURE__ */ f(A, { children: [
    Ee ?? /* @__PURE__ */ i(
      Tn,
      {
        variant: t,
        title: t === "card" ? a.links.card : a.links.decisionTree,
        badges: a.linkChip.badges,
        readOnly: h,
        selected: u,
        onClick: B
      }
    ),
    u && !h && /* @__PURE__ */ i(
      Nn,
      {
        anchorEl: wt,
        changeTargetLabel: a.linkChip.changeTarget,
        removeLabel: a.linkChip.remove,
        onChangeTarget: () => {
          t === "card" ? o.dispatchCommand(Dn, { nodeKey: e, cardId: n, tabId: r }) : o.dispatchCommand(En, { nodeKey: e, decisionTreeId: n });
        },
        onRemove: () => {
          o.update(() => {
            Ye(e)?.remove();
          });
        }
      }
    )
  ] });
}
function An(t) {
  const e = t.getAttribute("data-lexical-card-link-id");
  if (!e) return null;
  const n = t.getAttribute("data-lexical-card-link-tab-id") || void 0;
  return { node: at(e, n) };
}
class ee extends Z {
  __id;
  __tabId;
  static getType() {
    return "card-link";
  }
  static clone(e) {
    return new ee(e.__id, e.__tabId, e.__key);
  }
  static importJSON(e) {
    return at(e.id, e.tabId);
  }
  // No `format`/`version`-spread from a block base class: an inline decorator carries neither,
  // and this shape must exactly match what the backend's Lexical extraction already expects
  // (extractCardLinkIds.ts reads `id`/`tabId` off this same node type).
  exportJSON() {
    return {
      id: this.__id,
      tabId: this.__tabId,
      type: "card-link",
      version: 1
    };
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-lexical-card-link-id") ? { conversion: An, priority: 2 } : null
    };
  }
  exportDOM() {
    const e = document.createElement("span");
    return e.setAttribute("data-lexical-card-link-id", this.__id), this.__tabId && e.setAttribute("data-lexical-card-link-tab-id", this.__tabId), { element: e };
  }
  constructor(e, n, r) {
    super(r), this.__id = e, this.__tabId = n;
  }
  getId() {
    return this.__id;
  }
  getTabId() {
    return this.__tabId;
  }
  setTarget(e, n) {
    const r = this.getWritable();
    r.__id = e, r.__tabId = n;
  }
  isInline() {
    return !0;
  }
  createDOM() {
    const e = document.createElement("span");
    return e.style.display = "inline-block", e;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ i(it, { variant: "card", nodeKey: this.getKey(), id: this.__id, tabId: this.__tabId });
  }
}
function at(t, e) {
  return Y(new ee(t, e));
}
function zo(t) {
  return t instanceof ee;
}
function Pn(t) {
  const e = t.open !== void 0 ? t.open : !0;
  return {
    node: st(e)
  };
}
class te extends Q {
  __open;
  constructor(e, n) {
    super(n), this.__open = e;
  }
  static getType() {
    return "collapsible-container";
  }
  static clone(e) {
    return new te(e.__open, e.__key);
  }
  createDOM(e, n) {
    const r = document.createElement("details");
    return r.classList.add("Collapsible__container"), r.open = !1, r.addEventListener("toggle", () => {
      n.getEditorState().read(() => this.getOpen()) !== r.open && n.update(() => this.toggleOpen());
    }), r;
  }
  updateDOM(e, n) {
    return e.__open !== this.__open && (n.open = this.__open), !1;
  }
  static importDOM() {
    return {
      details: (e) => ({
        conversion: Pn,
        priority: 1
      })
    };
  }
  // A stored document opens closed, whatever it was saved as: the state a reader arrives in is
  // the same one for every reader, and a card that unfolds parts of itself on load buries the
  // rest of its content below them.
  static importJSON(e) {
    return st(!1);
  }
  exportDOM() {
    const e = document.createElement("details");
    return e.setAttribute("open", this.__open.toString()), { element: e };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      open: this.__open,
      type: "collapsible-container",
      version: 1
    };
  }
  setOpen(e) {
    const n = this.getWritable();
    n.__open = e;
  }
  getOpen() {
    return this.getLatest().__open;
  }
  toggleOpen() {
    this.setOpen(!this.getOpen());
  }
}
function st(t) {
  return new te(t);
}
function In(t) {
  return t instanceof te;
}
function Ln(t) {
  return {
    node: lt()
  };
}
class ne extends Q {
  static getType() {
    return "collapsible-content";
  }
  static clone(e) {
    return new ne(e.__key);
  }
  createDOM(e) {
    const n = document.createElement("div");
    return n.classList.add("Collapsible__content"), n;
  }
  updateDOM(e, n) {
    return !1;
  }
  static importDOM() {
    return {
      div: (e) => e.hasAttribute("data-lexical-collapsible-content") ? {
        conversion: Ln,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const e = document.createElement("div");
    return e.setAttribute("data-lexical-collapsible-content", "true"), { element: e };
  }
  static importJSON(e) {
    return lt();
  }
  isShadowRoot() {
    return !0;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "collapsible-content",
      version: 1
    };
  }
}
function lt() {
  return new ne();
}
function Rn(t) {
  return t instanceof ne;
}
function Yn(t) {
  const e = getComputedStyle(t).transitionDuration.split(",")[0].trim(), n = e.endsWith("ms") ? parseFloat(e) / 1e3 : parseFloat(e);
  return Number.isFinite(n) ? n * 1e3 : 0;
}
function We(t) {
  t.offsetHeight;
}
function Bn(t) {
  return {
    node: ct()
  };
}
class re extends Q {
  static getType() {
    return "collapsible-title";
  }
  static clone(e) {
    return new re(e.__key);
  }
  createDOM(e, n) {
    const r = document.createElement("summary");
    return r.classList.add("Collapsible__title"), r.addEventListener("click", (o) => {
      const a = o.currentTarget.parentElement, s = a?.querySelector(".Collapsible__content");
      if (!a || !s)
        return;
      o.preventDefault();
      const l = Yn(s);
      if (a.open) {
        a.setAttribute("data-collapsing", ""), s.style.height = `${s.scrollHeight}px`, We(s), s.style.height = "0px", setTimeout(() => {
          a.open = !1, a.removeAttribute("data-collapsing"), s.style.height = "";
        }, l);
        return;
      }
      a.open = !0, s.style.height = "0px", We(s), s.style.height = `${s.scrollHeight}px`, setTimeout(() => {
        s.style.height = "";
      }, l);
    }), r;
  }
  updateDOM(e, n) {
    return !1;
  }
  static importDOM() {
    return {
      summary: (e) => ({
        conversion: Bn,
        priority: 1
      })
    };
  }
  static importJSON(e) {
    return ct();
  }
  exportDOM() {
    return { element: document.createElement("summary") };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "collapsible-title",
      version: 1
    };
  }
  collapseAtStart(e) {
    return this.getParentOrThrow().insertBefore(this), !0;
  }
  insertNewAfter(e, n = !0) {
    const r = this.getParentOrThrow();
    if (!In(r))
      throw new Error(
        "CollapsibleTitleNode expects to be child of CollapsibleContainerNode"
      );
    if (r.getOpen()) {
      const a = this.getNextSibling();
      if (!Rn(a))
        throw new Error(
          "CollapsibleTitleNode expects to have CollapsibleContentNode sibling"
        );
      const s = a.getFirstChild();
      if (Wt(s))
        return s;
      const l = Be();
      return a.append(l), l;
    }
    const o = Be();
    return r.insertAfter(o, n), o;
  }
}
function ct() {
  return new re();
}
function Wo(t) {
  return t instanceof re;
}
function Hn(t) {
  const e = t.getAttribute("data-lexical-decision-tree-link-id");
  return e ? { node: ut(e) } : null;
}
class oe extends Z {
  __id;
  static getType() {
    return "decision-tree-link";
  }
  static clone(e) {
    return new oe(e.__id, e.__key);
  }
  static importJSON(e) {
    return ut(e.id);
  }
  exportJSON() {
    return {
      id: this.__id,
      type: "decision-tree-link",
      version: 1
    };
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-lexical-decision-tree-link-id") ? { conversion: Hn, priority: 2 } : null
    };
  }
  exportDOM() {
    const e = document.createElement("span");
    return e.setAttribute("data-lexical-decision-tree-link-id", this.__id), { element: e };
  }
  constructor(e, n) {
    super(n), this.__id = e;
  }
  getId() {
    return this.__id;
  }
  setTarget(e) {
    const n = this.getWritable();
    n.__id = e;
  }
  isInline() {
    return !0;
  }
  createDOM() {
    const e = document.createElement("span");
    return e.style.display = "inline-block", e;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ i(it, { variant: "tree", nodeKey: this.getKey(), id: this.__id });
  }
}
function ut(t) {
  return Y(new oe(t));
}
function Jo(t) {
  return t instanceof oe;
}
const $n = "data:image/svg+xml,%3csvg%20viewBox='-0.12979372698077785%200%2032.12979372698078%2032'%20xmlns='http://www.w3.org/2000/svg'%20width='2500'%20height='2480'%3e%3cpath%20d='M30.667%202H9.333A1.333%201.333%200%200%200%208%203.333V9l12%203.5L32%209V3.333A1.333%201.333%200%200%200%2030.667%202z'%20fill='%2341a5ee'/%3e%3cpath%20d='M32%209H8v7l12%203.5L32%2016z'%20fill='%232b7cd3'/%3e%3cpath%20d='M32%2016H8v7l12%203.5L32%2023z'%20fill='%23185abd'/%3e%3cpath%20d='M32%2023H8v5.667A1.333%201.333%200%200%200%209.333%2030h21.334A1.333%201.333%200%200%200%2032%2028.667z'%20fill='%23103f91'/%3e%3cpath%20d='M16.667%207H8v19h8.667A1.337%201.337%200%200%200%2018%2024.667V8.333A1.337%201.337%200%200%200%2016.667%207z'%20opacity='.1'/%3e%3cpath%20d='M15.667%208H8v19h7.667A1.337%201.337%200%200%200%2017%2025.667V9.333A1.337%201.337%200%200%200%2015.667%208z'%20opacity='.2'/%3e%3cpath%20d='M15.667%208H8v17h7.667A1.337%201.337%200%200%200%2017%2023.667V9.333A1.337%201.337%200%200%200%2015.667%208z'%20opacity='.2'/%3e%3cpath%20d='M14.667%208H8v17h6.667A1.337%201.337%200%200%200%2016%2023.667V9.333A1.337%201.337%200%200%200%2014.667%208z'%20opacity='.2'/%3e%3cpath%20d='M1.333%208h13.334A1.333%201.333%200%200%201%2016%209.333v13.334A1.333%201.333%200%200%201%2014.667%2024H1.333A1.333%201.333%200%200%201%200%2022.667V9.333A1.333%201.333%200%200%201%201.333%208z'%20fill='%23185abd'/%3e%3cpath%20d='M11.95%2021h-1.8l-2.1-6.9-2.2%206.9h-1.8l-2-10h1.8l1.4%207%202.1-6.8h1.5l2%206.8%201.4-7h1.7z'%20fill='%23fff'/%3e%3cpath%20d='M0%200h32v32H0z'%20fill='none'/%3e%3c/svg%3e", zn = "data:image/svg+xml,%3csvg%20viewBox='0%200%2056%2054'%20xmlns='http://www.w3.org/2000/svg'%20width='2500'%20height='2411'%3e%3cpath%20d='M9.9%200h36.2C51.6%200%2056%204.4%2056%209.9v34.2c0%205.5-4.4%209.9-9.9%209.9H9.9C4.4%2054%200%2049.6%200%2044.1V9.9C0%204.4%204.4%200%209.9%200z'%20fill='%23fa0f00'/%3e%3cpath%20d='M45%2031.2c-2.6-2.7-9.7-1.6-11.4-1.4-2.5-2.4-4.2-5.3-4.8-6.3.9-2.7%201.5-5.4%201.6-8.3%200-2.5-1-5.2-3.8-5.2-1%200-1.9.6-2.4%201.4-1.2%202.1-.7%206.3%201.2%2010.6-1.1%203.1-2.1%206.1-4.9%2011.4-2.9%201.2-9%204-9.5%207-.2.9.1%201.8.8%202.5.7.6%201.6.9%202.5.9%203.7%200%207.3-5.1%209.8-9.4%202.1-.7%205.4-1.7%208.7-2.3%203.9%203.4%207.3%203.9%209.1%203.9%202.4%200%203.3-1%203.6-1.9.5-1%20.2-2.1-.5-2.9zm-2.5%201.7c-.1.7-1%201.4-2.6%201-1.9-.5-3.6-1.4-5.1-2.6%201.3-.2%204.2-.5%206.3-.1.8.2%201.6.7%201.4%201.7zM25.8%2012.3c.2-.3.5-.5.8-.5.9%200%201.1%201.1%201.1%202-.1%202.1-.5%204.2-1.2%206.2-1.5-4-1.2-6.8-.7-7.7zm-.2%2019.4c.8-1.6%201.9-4.4%202.3-5.6.9%201.5%202.4%203.3%203.2%204.1%200%20.1-3.1.7-5.5%201.5zm-5.9%204c-2.3%203.8-4.7%206.2-6%206.2-.2%200-.4-.1-.6-.2-.3-.2-.4-.5-.3-.9.3-1.4%202.9-3.3%206.9-5.1z'%20fill='%23fff'/%3e%3c/svg%3e", Wn = "data:image/svg+xml,%3csvg%20viewBox='-0.12979372698077785%200%2032.152389301176754%2032'%20xmlns='http://www.w3.org/2000/svg'%20width='2500'%20height='2478'%3e%3cpath%20d='M18%202A14.041%2014.041%200%200%200%204%2016l17.737%203.737z'%20fill='%23ed6c47'/%3e%3cpath%20d='M18%202a14.041%2014.041%200%200%201%2014%2014l-7%204.758L18%2016z'%20fill='%23ff8f6b'/%3e%3cpath%20d='M18%2030a14.041%2014.041%200%200%200%2014-14H4a14.041%2014.041%200%200%200%2014%2014z'%20fill='%23d35230'/%3e%3cpath%20d='M16.666%207h-9.36a13.914%2013.914%200%200%200%20.93%2019h8.43A1.337%201.337%200%200%200%2018%2024.667V8.333A1.337%201.337%200%200%200%2016.666%207z'%20opacity='.1'/%3e%3cpath%20d='M15.666%208H6.54a13.906%2013.906%200%200%200%202.845%2019h6.282A1.337%201.337%200%200%200%2017%2025.667V9.333A1.337%201.337%200%200%200%2015.666%208z'%20opacity='.2'/%3e%3cpath%20d='M15.666%208H6.54a13.89%2013.89%200%200%200%20.766%2017h8.361A1.337%201.337%200%200%200%2017%2023.667V9.333A1.337%201.337%200%200%200%2015.666%208z'%20opacity='.2'/%3e%3cpath%20d='M14.666%208H6.54a13.89%2013.89%200%200%200%20.766%2017h7.361A1.337%201.337%200%200%200%2016%2023.667V9.333A1.337%201.337%200%200%200%2014.666%208z'%20opacity='.2'/%3e%3cpath%20d='M1.333%208h13.334A1.333%201.333%200%200%201%2016%209.333v13.334A1.333%201.333%200%200%201%2014.667%2024H1.333A1.333%201.333%200%200%201%200%2022.667V9.333A1.333%201.333%200%200%201%201.333%208z'%20fill='%23c43e1c'/%3e%3cpath%20d='M7.997%2011a4.168%204.168%200%200%201%202.755.805%202.878%202.878%200%200%201%20.956%202.331%202.726%202.726%200%200%201-.473%201.588%203.164%203.164%200%200%201-1.344%201.186%204.57%204.57%200%200%201-2.02.424h-1.91V21H4V11zM5.96%2015.683h1.687a2.194%202.194%200%200%200%201.492-.444%201.107%201.107%200%200%200%20.504-1.026q0-1.659-1.933-1.659H5.96z'%20fill='%23f9f7f7'/%3e%3cpath%20d='M0%200h32v32H0z'%20fill='none'/%3e%3c/svg%3e", Jn = D(N)({
  "& button": {
    background: "#fff",
    font: "inherit",
    cursor: "pointer",
    // The chip hugs its filename rather than ruling a box across the page; maxWidth keeps a
    // long one inside the column.
    maxWidth: "100%",
    // The space before the interpolation is load-bearing: `solid#D0D5DC` parses as nothing.
    border: `1px solid ${b[300]}`,
    padding: 8,
    borderRadius: 8,
    display: "inline-flex",
    gap: 8,
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
    textDecoration: "none",
    "& img": {
      height: 30,
      width: 30,
      display: "block"
    },
    "& .DocumentLink__name": {
      display: "block",
      fontSize: 14,
      fontWeight: 600,
      lineHeight: 1.3,
      color: b[800]
    },
    "& .DocumentLink__type": {
      display: "block",
      fontSize: 12,
      lineHeight: 1.3,
      color: b[400]
    },
    "& svg": {
      fontSize: 16,
      display: "block"
    },
    "& strong": {
      display: "block"
    }
  }
}), Vn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='-0.12979372698077785%200%2032.12979372698078%2032'%20width='2500'%20height='2480'%3e%3cg%20data-name='STYLE%20=%20COLOR'%3e%3cpath%20d='M20%202H9.333A1.333%201.333%200%200%200%208%203.333V9l12%207%206%202.532L32%2016V9z'%20fill='%2321a366'/%3e%3cpath%20fill='%23107c41'%20d='M8%209h12v7H8z'/%3e%3cpath%20d='M30.667%202H20v7h12V3.333A1.333%201.333%200%200%200%2030.667%202z'%20fill='%2333c481'/%3e%3cpath%20d='M20%2016H8v12.667A1.333%201.333%200%200%200%209.333%2030h21.334A1.333%201.333%200%200%200%2032%2028.667V23z'%20fill='%23185c37'/%3e%3cpath%20fill='%23107c41'%20d='M20%2016h12v7H20z'/%3e%3cpath%20d='M16.667%207H8v19h8.667A1.337%201.337%200%200%200%2018%2024.667V8.333A1.337%201.337%200%200%200%2016.667%207z'%20opacity='.1'/%3e%3cpath%20d='M15.667%208H8v19h7.667A1.337%201.337%200%200%200%2017%2025.667V9.333A1.337%201.337%200%200%200%2015.667%208z'%20opacity='.2'/%3e%3cpath%20d='M15.667%208H8v17h7.667A1.337%201.337%200%200%200%2017%2023.667V9.333A1.337%201.337%200%200%200%2015.667%208z'%20opacity='.2'/%3e%3cpath%20d='M14.667%208H8v17h6.667A1.337%201.337%200%200%200%2016%2023.667V9.333A1.337%201.337%200%200%200%2014.667%208z'%20opacity='.2'/%3e%3cpath%20data-name='Back%20Plate'%20d='M1.333%208h13.334A1.333%201.333%200%200%201%2016%209.333v13.334A1.333%201.333%200%200%201%2014.667%2024H1.333A1.333%201.333%200%200%201%200%2022.667V9.333A1.333%201.333%200%200%201%201.333%208z'%20fill='%23107c41'/%3e%3cpath%20d='M3.533%2021l3.236-5.014L3.805%2011H6.19l1.618%203.187q.223.453.307.676h.021q.16-.362.335-.704L10.2%2011h2.189l-3.04%204.958L12.466%2021h-2.33l-1.869-3.5a2.922%202.922%200%200%201-.223-.468h-.028a2.207%202.207%200%200%201-.216.453L5.877%2021z'%20fill='%23fff'/%3e%3cpath%20fill='none'%20d='M0%200h32v32H0z'/%3e%3c/g%3e%3c/svg%3e", Kn = /^media(\.preprod)?\.cogneed\.ai$/;
function qn(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}
function jn(t) {
  return encodeURIComponent(qn(t)).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`);
}
function Un(t) {
  let e;
  try {
    e = new URL(t);
  } catch {
    return t;
  }
  if (!Kn.test(e.hostname))
    return t;
  const n = e.pathname.split("/").map(jn).join("/");
  return `${e.origin}${n}${e.search}${e.hash}`;
}
function Gn(t) {
  const e = t.getAttribute("data-lexical-pdf-link-url"), n = t.getAttribute("data-lexical-pdf-link-name");
  return e && n ? { node: dt(e, n) } : null;
}
function Xn(t) {
  return ["pdf", "docx", "pptx", "xlsx"].includes(t);
}
function Qn({
  name: t,
  url: e,
  className: n,
  format: r,
  nodeKey: o
}) {
  const { strings: a, onDocumentLinkOpen: s } = C(), [l, c] = x.useState(!1), m = e.split(".").pop() || "", u = m.toLowerCase(), p = {
    pdf: { src: zn, alt: "Download PDF" },
    docx: { src: $n, alt: "Download Word Document" },
    pptx: { src: Wn, alt: "Download PowerPoint Presentation" },
    xlsx: { src: Vn, alt: "Download Excel File" }
  };
  return /* @__PURE__ */ i(
    Ue,
    {
      className: n,
      format: r,
      nodeKey: o,
      children: /* @__PURE__ */ i(Jn, { children: /* @__PURE__ */ f(
        "button",
        {
          type: "button",
          onClick: () => {
            s?.(Un(e));
          },
          onMouseEnter: () => c(!0),
          onMouseLeave: () => c(!1),
          children: [
            Xn(u) && /* @__PURE__ */ i("img", { src: p[u].src, alt: p[u].alt }),
            /* @__PURE__ */ f("div", { children: [
              /* @__PURE__ */ i("span", { className: "DocumentLink__name", children: t }),
              /* @__PURE__ */ i("span", { className: "DocumentLink__type", children: l ? a.links.document : m })
            ] })
          ]
        }
      ) })
    }
  );
}
class ie extends Ge {
  __url;
  __name;
  static getType() {
    return "pdf-link";
  }
  static clone(e) {
    return new ie(e.__url, e.__name, e.__format, e.__key);
  }
  static importJSON(e) {
    const n = dt(e.url, e.name);
    return n.setFormat(e.format), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      url: this.getUrl(),
      name: this.getName(),
      type: "pdf-link",
      version: 1
    };
  }
  static importDOM() {
    return {
      div: (e) => !e.hasAttribute("data-lexical-pdf-link-url") || !e.hasAttribute("data-lexical-pdf-link-name") ? null : {
        conversion: Gn,
        priority: 2
      }
    };
  }
  exportDOM() {
    const e = document.createElement("div");
    return e.setAttribute("data-lexical-pdf-link-url", this.__url), e.setAttribute("data-lexical-pdf-link-name", this.__name), { element: e };
  }
  constructor(e, n, r, o) {
    super(r, o), this.__url = e, this.__name = n;
  }
  getUrl() {
    return this.__url;
  }
  getName() {
    return this.__name;
  }
  decorate(e, n) {
    const r = n.theme.embedBlock || {}, o = {
      base: r.base || "",
      focus: r.focus || ""
    };
    return /* @__PURE__ */ i(
      Qn,
      {
        className: o,
        format: this.__format,
        nodeKey: this.getKey(),
        url: this.__url,
        name: this.__name
      }
    );
  }
  isTopLevel() {
    return !0;
  }
}
function dt(t, e) {
  return new ie(t, e);
}
function Vo(t) {
  return t instanceof ie;
}
const mt = x.createContext(null);
function O() {
  const t = x.useContext(mt);
  if (t === null) throw new Error("useFormulaNodeContext must be used within a FormulaNodeContextProvider");
  return t;
}
const se = "commitment";
function Zn() {
  const { strings: t } = C(), {
    state: e,
    updateState: n,
    setExpanded: r,
    expanded: o,
    completedSteps: { commitment: a }
  } = O();
  function s(u) {
    n((p) => ({ ...p, commitmentDuration: u }));
  }
  function l(u) {
    n((p) => ({ ...p, startDate: u }));
  }
  function c(u) {
    n((p) => ({ ...p, hasEquipment: u }));
  }
  const m = x.useMemo(() => e.hasEquipment === void 0 ? "" : e.hasEquipment ? "equipment" : "no-equipment", [e.hasEquipment]);
  return /* @__PURE__ */ f(
    ye,
    {
      expanded: o === se,
      onChange: () => {
        r(o === se ? null : se);
      },
      className: "section",
      elevation: 0,
      TransitionProps: { unmountOnExit: !0 },
      children: [
        /* @__PURE__ */ i(W, { expandIcon: !a || o === se ? /* @__PURE__ */ i(V, {}) : /* @__PURE__ */ i(Ie, { className: "checked" }), children: t.formula.commitment.title }),
        /* @__PURE__ */ f(J, { children: [
          /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.commitment.initialTitle }),
            /* @__PURE__ */ i(
              k,
              {
                select: !0,
                sx: { width: 230 },
                defaultValue: e.commitmentDuration ?? "",
                onChange: (u) => {
                  const { value: p } = u.target, d = parseInt(p, 10);
                  s(d);
                },
                SelectProps: {
                  displayEmpty: !0,
                  MenuProps: {
                    anchorOrigin: { vertical: "bottom", horizontal: 2 },
                    transformOrigin: { vertical: -6, horizontal: 2 }
                  },
                  renderValue(u) {
                    return u !== "" ? t.formula.commitment.initialOption(String(u)) : t.formula.commitment.initialPlaceholder;
                  }
                },
                children: ["0", "12", "24"].map((u) => /* @__PURE__ */ i(_e, { value: u, children: t.formula.commitment.initialOption(u) }, u))
              }
            )
          ] }),
          /* @__PURE__ */ i(R, { in: !!e.commitmentDuration, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.commitment.endTitle }),
            !!e.commitmentDuration && /* @__PURE__ */ i(
              Ze,
              {
                disablePast: !0,
                format: "dd/MM/yyyy",
                slotProps: {
                  textField: { sx: { width: 175 } }
                },
                value: e.startDate ? de(e.startDate, e.commitmentDuration) : null,
                maxDate: de(Date.now(), e.commitmentDuration),
                onChange: (u) => {
                  u && !me(u.getTime()) && e.commitmentDuration && l(de(u, -e.commitmentDuration));
                }
              }
            )
          ] }) }),
          /* @__PURE__ */ i(R, { in: e.commitmentDuration === 24 && e.startDate && e.startDate.getFullYear() > 2022, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.commitment.hasEquipmentTitle }),
            /* @__PURE__ */ i(g, { variant: "body1", children: t.formula.commitment.hasEquipmentDescription }),
            /* @__PURE__ */ f(
              je,
              {
                onChange: (u) => {
                  c(u.target.value === "equipment");
                },
                className: "radio",
                defaultValue: m,
                children: [
                  /* @__PURE__ */ i(he, { value: "equipment", control: /* @__PURE__ */ i(ge, {}), label: t.formula.commitment.hasEquipmentTrue }),
                  /* @__PURE__ */ i(he, { value: "no-equipment", control: /* @__PURE__ */ i(ge, {}), label: t.formula.commitment.hasEquipmentFalse })
                ]
              }
            )
          ] }) })
        ] })
      ]
    }
  );
}
const er = {
  __typename: "BoxPrice",
  firstYear: 19.99,
  secondYear: 29.99,
  id: "revolution-light",
  name: "Révolution Light",
  setupFees: 49.99
}, tr = {
  __typename: "BoxPrice",
  firstYear: 29.99,
  secondYear: 39.99,
  id: "box-5g",
  name: "Box 5G",
  setupFees: 29
}, nr = {
  __typename: "BoxPrice",
  firstYear: 29.99,
  secondYear: 39.99,
  id: "pop",
  name: "POP"
}, rr = {
  __typename: "BoxPrice",
  firstYear: 39.99,
  secondYear: 49.99,
  name: "Delta POP",
  id: "delta-pop"
}, or = {
  __typename: "BoxPrice",
  firstYear: 39.99,
  secondYear: 49.99,
  name: "Ultra Essentielle",
  id: "ultra-essentielle"
}, ir = {
  __typename: "BoxPrice",
  firstYear: 49.99,
  secondYear: 59.99,
  name: "Ultra",
  id: "ultra"
}, ar = {
  __typename: "MobilePrice",
  firstYear: 19.99,
  name: "Free 5G",
  id: "free-5g"
}, sr = {
  __typename: "MobilePrice",
  firstYear: 9.99,
  secondYear: 15.99,
  name: "Free 5G avec avantage Freebox Ultra",
  id: "free-5g-ultra"
}, lr = {
  __typename: "MobilePrice",
  firstYear: 15.99,
  name: "Free 5G avec avantage Freebox",
  id: "free-5g-avantage-box"
}, cr = {
  __typename: "MobilePrice",
  firstYear: 9.99,
  name: "Free 5G avec avantage Freebox POP",
  id: "free-5g-avantage-pop"
}, pt = {
  __typename: "MobilePrice",
  name: "Série Free avec avantage Box",
  id: "serie-free-box",
  secondYear: 15.99
}, ur = {
  __typename: "MobilePrice",
  name: "Série Free",
  id: "serie-free",
  secondYear: 19.99
}, dr = [
  er,
  tr,
  nr,
  rr,
  or,
  ir,
  ar,
  sr,
  lr,
  cr
], ht = [
  {
    name: "Orange",
    closingFee: 50
  },
  {
    name: "SFR",
    closingFee: 49
  },
  {
    name: "Bouygues Telecom",
    closingFee: 59
  },
  {
    name: "Sosh",
    closingFee: 50
  },
  {
    name: "RED by SFR",
    closingFee: 49
  }
], le = "contract";
function mr() {
  const { strings: t } = C(), {
    state: e,
    updateState: n,
    setExpanded: r,
    expanded: o,
    completedSteps: { contract: a }
  } = O();
  function s(c) {
    n(c === "mobile" ? (m) => ({
      ...m,
      contractType: "mobile",
      operator: void 0,
      newOffer: void 0
    }) : (m) => ({
      ...m,
      contractType: "box",
      operator: void 0,
      newOffer: void 0
    }));
  }
  function l(c) {
    n((m) => ({ ...m, operator: c }));
  }
  return /* @__PURE__ */ f(
    ye,
    {
      expanded: o === le,
      onChange: () => {
        r(o === le ? null : le);
      },
      className: "section",
      elevation: 0,
      TransitionProps: { unmountOnExit: !0 },
      children: [
        /* @__PURE__ */ i(W, { expandIcon: !a || o === le ? /* @__PURE__ */ i(V, {}) : /* @__PURE__ */ i(Ie, { className: "checked" }), children: t.formula.contract.title }),
        /* @__PURE__ */ f(J, { children: [
          /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.contract.deviceTitle }),
            /* @__PURE__ */ f(
              je,
              {
                onChange: (c) => {
                  s(c.target.value);
                },
                className: "radio",
                defaultValue: e.contractType ?? "",
                children: [
                  /* @__PURE__ */ i(he, { value: "mobile", control: /* @__PURE__ */ i(ge, {}), label: t.formula.contract.mobile }),
                  /* @__PURE__ */ i(he, { value: "box", control: /* @__PURE__ */ i(ge, {}), label: t.formula.contract.box })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ i(R, { in: e.contractType === "box", mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.contract.operatorTitle }),
            /* @__PURE__ */ i(
              k,
              {
                select: !0,
                onChange: (c) => {
                  l(c.target.value);
                },
                defaultValue: e.operator ?? "",
                sx: { width: 220 },
                SelectProps: {
                  MenuProps: {
                    anchorOrigin: { vertical: "bottom", horizontal: 2 },
                    transformOrigin: { vertical: -6, horizontal: 2 }
                  },
                  displayEmpty: !0,
                  renderValue(c) {
                    return c !== "" ? /* @__PURE__ */ i(A, { children: c }) : t.formula.contract.operatorPlaceholder;
                  }
                },
                children: ht.map((c) => /* @__PURE__ */ i(_e, { value: c.name, children: c.name }, c.name))
              }
            )
          ] }) })
        ] })
      ]
    }
  );
}
function _({ resultKey: t, values: e }) {
  const { renderFormulaResult: n } = C();
  return n ? /* @__PURE__ */ i(A, { children: n(t, e) }) : /* @__PURE__ */ i(A, { children: Object.values(e).filter((r) => r !== void 0).join(" ") });
}
const Le = D(ye)({
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  "&.Mui-expanded": {
    margin: "4px 0px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    "& .MuiAccordionDetails-root": {
      borderTop: `1px solid ${T(b[300], 0.5)}`
    }
  },
  "& .MuiAccordionSummary-content": {
    margin: "8px 0px",
    "&.Mui-expanded": {
      margin: "12px 0px"
    }
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 0,
    color: b[800],
    fontSize: 14,
    lineHeight: "20px"
  },
  "& .MuiAccordionDetails-root": {
    "& strong": {
      fontWeight: 600
    },
    "& .MuiTypography-caption": {
      backgroundColor: T(y[300], 0.3),
      border: `0px solid ${T(y[300], 0.8)}`,
      borderLeftWidth: 4,
      fontSize: 14,
      lineHeight: "20px",
      padding: "4px 16px",
      margin: "8px -16px -16px -16px"
    }
  }
});
function pr(t) {
  const { terminationFees: e, expanded: n, expand: r } = t, { locale: o } = C(), a = new Intl.NumberFormat(o, { style: "currency", currency: "EUR", signDisplay: "always" }), s = new Intl.NumberFormat(o, { style: "currency", currency: "EUR" }), l = new Intl.NumberFormat(o, { style: "percent", maximumFractionDigits: 0 });
  return /* @__PURE__ */ f(Le, { elevation: 0, expanded: n, onChange: () => {
    r();
  }, children: [
    /* @__PURE__ */ f(W, { expandIcon: /* @__PURE__ */ i(V, {}), children: [
      /* @__PURE__ */ i("div", { className: "step-number", "data-step-number": 2 }),
      /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesTotal",
          values: { total: s.format(e.amountAfterReimbursement ?? e.amountToPay) }
        }
      )
    ] }),
    /* @__PURE__ */ f(J, { children: [
      e.firstYear && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesFirstYear",
          values: { total: a.format(e.firstYear.total), count: e.firstYear.months, monthly: s.format(e.firstYear.monthly) }
        }
      ) }),
      e.secondYear && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesSecondYear",
          values: {
            total: a.format(e.secondYear.total),
            count: e.secondYear.months,
            monthly: s.format(e.secondYear.monthly),
            ratio: l.format(e.secondYear.ratio)
          }
        }
      ) }),
      e.boxTerminationFee && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesBoxFee",
          values: { total: a.format(e.boxTerminationFee) }
        }
      ) }),
      /* @__PURE__ */ i(ve, {}),
      /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesAmountToPay",
          values: { total: s.format(e.amountToPay) }
        }
      ) }),
      e.reimbursement && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesReimbursement",
          values: { total: a.format(-e.reimbursement) }
        }
      ) }),
      e.amountAfterReimbursement !== void 0 && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "feesAmountAfterReimbursement",
          values: { total: s.format(e.amountAfterReimbursement) }
        }
      ) }),
      e.law && /* @__PURE__ */ i(g, { variant: "caption", component: "p", children: e.law })
    ] })
  ] });
}
function hr(t) {
  const { currentOfferCost: e, expanded: n, expand: r } = t, { locale: o } = C(), a = new Intl.NumberFormat(o, { style: "currency", currency: "EUR", signDisplay: "always" }), s = new Intl.NumberFormat(o, { style: "currency", currency: "EUR" });
  return /* @__PURE__ */ f(Le, { elevation: 0, expanded: n, onChange: () => {
    r();
  }, children: [
    /* @__PURE__ */ f(W, { expandIcon: /* @__PURE__ */ i(V, {}), children: [
      /* @__PURE__ */ i("div", { className: "step-number", "data-step-number": 1 }),
      /* @__PURE__ */ i(
        _,
        {
          resultKey: "currentCostTotal",
          values: { total: s.format(e.total), count: e.commitmentLeft }
        }
      )
    ] }),
    /* @__PURE__ */ f(J, { children: [
      e.promo && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "offerLine",
          values: { total: a.format(e.promo.total), count: e.promo.months, monthly: s.format(e.promo.monthly) }
        }
      ) }),
      e.normal && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "offerLine",
          values: { total: a.format(e.normal.total), count: e.normal.months, monthly: s.format(e.normal.monthly) }
        }
      ) }),
      /* @__PURE__ */ i(ve, {}),
      /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "total",
          values: { total: s.format(e.total) }
        }
      ) })
    ] })
  ] });
}
function fr(t) {
  const { expanded: e, expand: n } = t, { locale: r } = C(), { newOfferCost: o, currentOfferCost: a } = O(), s = (o?.firstYear.months ?? 0) + (o?.secondYear?.months ?? 0), l = new Intl.NumberFormat(r, { style: "currency", currency: "EUR", signDisplay: "always" }), c = new Intl.NumberFormat(r, { style: "currency", currency: "EUR" });
  return o ? /* @__PURE__ */ f(Le, { elevation: 0, expanded: e, onChange: () => {
    n();
  }, children: [
    /* @__PURE__ */ f(W, { expandIcon: /* @__PURE__ */ i(V, {}), children: [
      /* @__PURE__ */ i("div", { className: "step-number", "data-step-number": 3 }),
      /* @__PURE__ */ i(
        _,
        {
          resultKey: "newOfferTitle",
          values: { total: c.format(o.total), count: a?.commitmentLeft ?? 0, months: s }
        }
      )
    ] }),
    /* @__PURE__ */ f(J, { children: [
      o.firstYear && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "offerLine",
          values: { total: l.format(o.firstYear.total), count: o.firstYear.months, monthly: c.format(o.firstYear.monthly) }
        }
      ) }),
      o.secondYear && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "offerLine",
          values: { total: l.format(o.secondYear.total), count: o.secondYear.months, monthly: c.format(o.secondYear.monthly) }
        }
      ) }),
      o.setupFee && /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "newOfferSetupFee",
          values: { total: l.format(o.setupFee) }
        }
      ) }),
      /* @__PURE__ */ i(ve, {}),
      /* @__PURE__ */ i(g, { variant: "body2", children: /* @__PURE__ */ i(
        _,
        {
          resultKey: "total",
          values: { total: c.format(o.total) }
        }
      ) })
    ] })
  ] }) : null;
}
const gr = D(N)({
  backgroundColor: "white",
  borderTop: `1px solid ${b[300]}`,
  padding: "8px 16px",
  "& > .MuiTypography-subtitle1": {
    fontSize: 14,
    lineHeight: "20px"
  },
  "& .number": {
    padding: "0px 4px",
    borderRadius: 4,
    color: F[100],
    backgroundColor: F[600],
    "&.negative": {
      color: I[100],
      backgroundColor: I[600]
    }
  },
  "& > .MuiBox-root": {
    display: "flex",
    alignItems: "center",
    marginTop: 4,
    gap: 4,
    "& [data-step-number]:not(.step-number)": {
      padding: "0px 4px",
      borderRadius: 4
    },
    "& .MuiTypography-body1": {
      fontSize: 14,
      lineHeight: "20px",
      fontWeight: 700
    }
  }
});
function br() {
  const {
    currentOfferCost: t,
    terminationFees: e,
    savings: n,
    newOfferCost: r
  } = O(), { locale: o } = C(), a = new Intl.NumberFormat(o, { style: "currency", currency: "EUR", signDisplay: "always" }), s = new Intl.NumberFormat(o, { style: "currency", currency: "EUR" });
  return t === void 0 || e === void 0 || n === void 0 || r === void 0 ? null : /* @__PURE__ */ f(gr, { children: [
    /* @__PURE__ */ i(g, { variant: "subtitle1", className: fe({ negative: n.result < 0 }), children: /* @__PURE__ */ i(
      _,
      {
        resultKey: "savings",
        values: { total: a.format(n.result), count: t.commitmentLeft || 12 }
      }
    ) }),
    /* @__PURE__ */ f(N, { children: [
      /* @__PURE__ */ i(g, { className: fe("number", { negative: n.result < 0 }), children: a.format(n.result) }),
      /* @__PURE__ */ i(g, { variant: "body2", children: "=" }),
      /* @__PURE__ */ i(g, { "data-step-number": 1, children: s.format(t.total) }),
      /* @__PURE__ */ i(g, { children: "-" }),
      /* @__PURE__ */ i(g, { "data-step-number": 2, children: s.format(e.amountAfterReimbursement ?? e.amountToPay) }),
      /* @__PURE__ */ i(g, { children: "-" }),
      /* @__PURE__ */ i(g, { "data-step-number": 3, children: s.format(r.total) })
    ] })
  ] });
}
const xr = D(N)({
  padding: "6px 8px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: b[100],
  "& .step-number": {
    position: "relative",
    width: 20,
    height: 20,
    borderRadius: "50%",
    marginRight: 4,
    color: "white",
    "&::before": {
      position: "absolute",
      top: 0,
      left: "50%",
      transform: "translate(-50%, 0px)",
      content: "attr(data-step-number)",
      fontSize: 14,
      lineHeight: "20px"
    }
  },
  "& [data-step-number]": { fontWeight: 700 },
  '& [data-step-number="1"]': { backgroundColor: $e[300], color: $e[500] },
  '& [data-step-number="2"]': { backgroundColor: He[100], color: He[600] },
  '& [data-step-number="3"]': { backgroundColor: y[300], color: y[500] }
});
function yr() {
  const {
    currentOfferCost: t,
    terminationFees: e
  } = O(), [n, r] = x.useState(null), o = (a) => ({
    expand() {
      r(n === a ? null : a);
    },
    expanded: n === a
  });
  return t === void 0 || e === void 0 ? null : /* @__PURE__ */ f(xr, { children: [
    /* @__PURE__ */ i(hr, { currentOfferCost: t, ...o("currentCost") }),
    /* @__PURE__ */ i(pr, { terminationFees: e, ...o("fees") }),
    /* @__PURE__ */ i(fr, { ...o("newCost") }),
    /* @__PURE__ */ i(br, {})
  ] });
}
const ce = "price";
function _r() {
  const { strings: t, locale: e } = C(), n = new Intl.NumberFormat(e, { style: "unit", unit: "month", unitDisplay: "long" }), {
    state: r,
    updateState: o,
    setExpanded: a,
    expanded: s,
    completedSteps: { price: l }
  } = O();
  function c(d) {
    o((h) => ({ ...h, normalPrice: d }));
  }
  function m(d) {
    o((h) => ({ ...h, promotionDuration: d, ...d === 0 && { promotionPrice: void 0 } }));
  }
  function u(d) {
    o((h) => ({ ...h, promotionPrice: d }));
  }
  function p(d) {
    o((h) => ({ ...h, startDate: d }));
  }
  return /* @__PURE__ */ f(
    ye,
    {
      expanded: s === ce,
      onChange: () => {
        a(s === ce ? null : ce);
      },
      className: "section",
      elevation: 0,
      TransitionProps: { unmountOnExit: !0 },
      children: [
        /* @__PURE__ */ i(W, { expandIcon: !l || s === ce ? /* @__PURE__ */ i(V, {}) : /* @__PURE__ */ i(Ie, { className: "checked" }), children: t.formula.price.title }),
        /* @__PURE__ */ f(J, { children: [
          /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.price.promotionDuration }),
            /* @__PURE__ */ i(
              k,
              {
                select: !0,
                onChange: (d) => {
                  const h = Number(d.target.value).valueOf();
                  m(h);
                },
                defaultValue: r.promotionDuration ?? "",
                SelectProps: {
                  MenuProps: {
                    anchorOrigin: { vertical: "bottom", horizontal: 2 },
                    transformOrigin: { vertical: -6, horizontal: 2 }
                  },
                  displayEmpty: !0,
                  renderValue(d) {
                    return d === "" ? t.formula.price.promotionPlaceholder : d === 0 ? /* @__PURE__ */ i(A, { children: "Pas de promotion" }) : /* @__PURE__ */ i(A, { children: n.format(parseInt(d, 10)) });
                  }
                },
                children: [0, 6, 12].map((d) => /* @__PURE__ */ i(_e, { value: d, children: d ? n.format(d) : "Pas de promotion" }, d))
              }
            )
          ] }),
          /* @__PURE__ */ i(R, { in: !!r.promotionDuration, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.price.promotionPrice }),
            r.promotionDuration && /* @__PURE__ */ i(
              k,
              {
                sx: { width: 100 },
                type: "number",
                defaultValue: r.promotionPrice ?? "",
                onChange: (d) => {
                  const h = Number(d.target.value).valueOf();
                  me(h) || u(h);
                },
                InputProps: {
                  inputProps: { min: 0 },
                  endAdornment: /* @__PURE__ */ i(g, { variant: "body1", children: "€" })
                }
              }
            )
          ] }) }),
          /* @__PURE__ */ i(R, { in: r.promotionDuration !== void 0, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.price.priceTitle }),
            /* @__PURE__ */ i(
              k,
              {
                sx: { width: 100 },
                type: "number",
                defaultValue: r.normalPrice ?? "",
                onChange: (d) => {
                  const h = Number(d.target.value).valueOf();
                  me(h) || c(h);
                },
                InputProps: {
                  inputProps: { min: 0 },
                  endAdornment: /* @__PURE__ */ i(g, { variant: "body1", children: "€" })
                }
              }
            )
          ] }) }),
          /* @__PURE__ */ i(R, { in: !!r.promotionDuration && !r.commitmentDuration, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ f(M, { children: [
            /* @__PURE__ */ i(g, { variant: "h4", children: t.formula.price.promotionStart }),
            !!r.promotionDuration && /* @__PURE__ */ i(
              Ze,
              {
                disableFuture: !0,
                format: "dd/MM/yyyy",
                value: r.startDate ?? null,
                slotProps: {
                  textField: { sx: { width: 175 } }
                },
                onChange: (d) => {
                  d && !me(d.getTime()) && p(d);
                }
              }
            )
          ] }) }),
          /* @__PURE__ */ i(N, { className: "actions", children: l && /* @__PURE__ */ i(pe, { onClick: () => {
            a("new-offer");
          }, color: "info", variant: "outlined", children: t.formula.next }) })
        ] })
      ]
    }
  );
}
const vr = D(N)(({ theme: t }) => ({
  border: `1px solid ${b[300]}`,
  borderRadius: "4px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  maxWidth: 600,
  "& .MuiTypography-root": {
    textAlign: "left"
  },
  "& > .MuiBox-root.header": {
    padding: "8px 12px 4px 12px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& > .MuiTypography-subtitle1": {
      fontSize: 16,
      lineHeight: "20px",
      fontWeight: 700
    },
    "& .MuiButton-root": {
      minWidth: 0,
      textTransform: "none",
      "& svg": {
        color: b[400],
        transition: t.transitions.create("transform", {
          duration: t.transitions.duration.shortest
        }),
        transform: "rotate(180deg)",
        fontSize: 20
      },
      "&.collapsed": {
        "& svg": { transform: "rotate(0deg)" }
      }
    }
  },
  "& .MuiFormControlLabel-root": {
    marginLeft: 0,
    "& .MuiRadio-root": {
      padding: 4
    }
  },
  "& .MuiTextField-root": {
    "& .Mui-focused": {
      backgroundColor: T(b[300], 0.5)
    }
  },
  "& .MuiInputBase-inputAdornedEnd": {
    padding: "11.5px 0px 11.5px 14px"
  },
  "& .MuiSelect-select": {
    padding: "11.5px 32px 11.5px 14px"
  },
  "& .MuiTypography-body1.label": {
    fontSize: 13,
    padding: "0px 8px"
  },
  "& .MuiCheckbox-root": {
    padding: 9,
    "& .MuiSvgIcon-root": {
      fontSize: 20
    }
  },
  "& .MuiBox-root.fields": {
    backgroundColor: T(b[100], 1),
    border: `medium solid ${b[300]}`,
    borderWidth: "1px 0px",
    padding: "6px 8px",
    display: "flex",
    flexDirection: "column",
    "& .MuiAccordionSummary-root": {
      "&.Mui-expanded": {
        minHeight: 48
      },
      "& .MuiAccordionSummary-content": {
        fontSize: 14,
        "&.Mui-expanded": {
          margin: "10px 0px"
        }
      },
      "& .MuiAccordionSummary-expandIconWrapper": {
        "& .MuiSvgIcon-root.checked": {
          fontSize: 20,
          color: F[500]
        }
      }
    },
    "& .MuiAccordionDetails-root": {
      marginTop: 4,
      backgroundColor: "white",
      padding: "4px 8px",
      borderRadius: 6,
      display: "flex",
      gap: 8,
      justifyContent: "stretch",
      flexWrap: "wrap",
      "& > .MuiFormControl-root": {
        padding: "4px 8px",
        "& > .MuiTypography-body1": {
          fontSize: 13,
          lineHeight: "16px"
        }
      },
      "& .MuiCollapse-wrapperInner": {
        padding: "4px 8px"
      },
      "& .MuiTypography-h4": {
        fontSize: 13,
        fontWeight: 600,
        color: b[400],
        lineHeight: "16px",
        marginBottom: 4
      },
      "& > .MuiBox-root": {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        "&.actions": {
          justifyContent: "flex-end"
        }
      }
    }
  }
})), ft = x.createContext(null);
function Cr(t) {
  const { children: e } = t, { draftStorage: n } = C(), r = `wysiwyg.resiliation-fee.offer.${pt.id}`, o = n?.read(r), a = o ? parseFloat(o) : 10.99, s = x.useMemo(() => ({
    updatePrice(l) {
      n?.write(r, String(l));
    },
    price: a
  }), [o, n, r]);
  return /* @__PURE__ */ i(ft.Provider, { value: s, children: e });
}
function z(t, e) {
  if (t === void 0 || t === 0 || e === void 0) return;
  const n = de(Te(e), t);
  return Zt(Te(n), Te(Date.now())) + 1;
}
function wr(t) {
  if (t.promotionDuration === void 0 || t.normalPrice === void 0 || t.commitmentDuration === void 0) return;
  const e = z(t.commitmentDuration, t.startDate) || 12, n = z(t.promotionDuration, t.startDate), r = z(t.commitmentDuration, t.startDate);
  if (!n || n < 0)
    return {
      normal: {
        months: e,
        monthly: t.normalPrice,
        total: e * t.normalPrice
      },
      total: e * t.normalPrice,
      commitmentLeft: r ?? 0
    };
  if (n) {
    if (t.promotionPrice === void 0) return;
    const o = {
      total: n * t.promotionPrice,
      monthly: t.promotionPrice,
      months: n
    }, a = {
      months: e - n,
      monthly: t.normalPrice,
      total: Math.max(0, e - n) * t.normalPrice
    };
    return {
      normal: a.months === 0 ? void 0 : a,
      promo: o,
      total: o.total + a.total,
      commitmentLeft: r ?? 0
    };
  }
  throw new Error("Not implemented");
}
function Fr(t) {
  if (t.newOffer === void 0) return;
  const e = t.newOffer, n = z(t.commitmentDuration, t.startDate) ?? 12, r = Math.min(n, 12), o = {
    monthly: e.firstYear,
    months: r,
    total: e.firstYear * r
  }, a = Math.max(n - 12, 0), s = a ? {
    monthly: e.secondYear ?? e.firstYear,
    months: a,
    total: (e.secondYear ?? e.firstYear) * a
  } : void 0;
  return {
    firstYear: o,
    ...s && { secondYear: s },
    setupFee: e.setupFees,
    total: o.total + (s?.total ?? 0) + (e.setupFees ?? 0)
  };
}
function Mr(t, e, n) {
  if (t === void 0 || e === void 0 || n === void 0) return;
  const r = e.total, o = n.total, a = t.amountAfterReimbursement ?? t.amountToPay;
  return {
    result: r - o - a
  };
}
function Nr(t) {
  return t.commitmentDuration === 0 ? [
    "Contrat sans engagement de durée",
    0
  ] : t.commitmentDuration === 12 ? [
    "Contrat avec engagement de 12 mois : L'abonné doit payer l’intégralité des mensualités restent dues.",
    0
  ] : t.startDate?.getFullYear() === 2022 ? [
    "Souscription validée avant le 1er janvier 2023 : Contrat avec engagement de 24 mois : l’abonné doit payer l’intégralité des mensualités restant dues sur la première année, puis 25% des mensualités de la 2nde année.",
    0.25
  ] : t.hasEquipment ? [
    "Souscription validée après le 1er janvier 2023 : Contrat avec engagement de 24 mois comprenant la vente d’un équipement subventionné (téléphone, télévision, console de jeux…) : l’abonné doit payer l’intégralité des mensualités restant dues sur la première année, puis 20% des mensualités de la 2nde année.",
    0.2
  ] : [
    "Souscription validée après le 1er janvier 2023 : Contrat avec engagement de 24 mois ne comprenant pas la vente d’un équipement subventionné : L’abonné doit payer l’intégralité des mensualités restant dues sur la première année, puis n’est pas redevable des sommes dues au titre de la période d’engagement restant à courir de la 2nde année.",
    0
  ];
}
function Dr(t, e, n) {
  if (t === 0) return;
  if (!n) throw new Error("Missing start date");
  const r = z(t, n);
  if (r === void 0) return;
  let o = r;
  if (t === 24 && (o = Math.max(0, o - 12)), o !== 0)
    return {
      total: o * e,
      months: o,
      monthly: e
    };
}
function Er(t, e, n, r) {
  if (t === 0 || n === 0) return;
  if (!r) throw new Error("Missing start date");
  const o = z(t, r);
  if (o === void 0) return;
  let a = o, s = 0;
  if (t === 24 && (a = Math.max(0, a - 12), s = o - a), s !== 0)
    return {
      total: s * e * n,
      months: s,
      monthly: e,
      ratio: n
    };
}
function Or(t) {
  if (t.contractType === void 0 || t.contractType === "box" && t.operator === void 0 || t.commitmentDuration === void 0 || t.promotionDuration === void 0 || t.commitmentDuration !== 0 && t.startDate === void 0 || t.promotionDuration !== 0 && t.startDate === void 0 || t.normalPrice === void 0) return;
  const [e, n] = Nr(t), r = Dr(t.commitmentDuration, t.normalPrice, t.startDate), o = Er(t.commitmentDuration, t.normalPrice, n, t.startDate), a = ht.find((m) => m.name === t.operator)?.closingFee, s = (r?.total ?? 0) + (o?.total ?? 0) + (a ?? 0), l = a ? Math.min(100, s) : void 0, c = l ? s - l : void 0;
  return {
    law: e,
    firstYear: r,
    secondYear: o,
    boxTerminationFee: a,
    amountToPay: s,
    reimbursement: l,
    amountAfterReimbursement: c
  };
}
function Sr(t) {
  return !(t.normalPrice === void 0 || t.promotionDuration === void 0 || t.promotionDuration && t.promotionPrice === void 0);
}
function Tr(t) {
  return t.contractType === "mobile" || t.contractType === "box" && t.operator !== void 0;
}
function kr(t) {
  return !(t.commitmentDuration === void 0 || t.commitmentDuration && t.startDate === void 0 || t.commitmentDuration === 24 && t.startDate && t.startDate.getFullYear() >= 2023 && t.hasEquipment === void 0);
}
function Ar(t) {
  return {
    price: Sr(t),
    contract: Tr(t),
    commitment: kr(t)
  };
}
function Pr(t) {
  const { children: e } = t, [n, r] = x.useState({}), [o, a] = x.useState("contract"), s = x.useMemo(() => Or(n), [n]), l = x.useMemo(() => wr(n), [n]), c = x.useMemo(() => Fr(n), [n]), m = x.useMemo(
    () => Mr(s, l, c),
    [s, l, c]
  ), u = x.useMemo(() => Ar(n), [n]), p = x.useRef(u);
  x.useEffect(() => {
    if (u.contract && !p.current.contract) {
      a("commitment"), p.current = u;
      return;
    }
    if (u.commitment && !p.current.commitment) {
      a("price"), p.current = u;
      return;
    }
    p.current = u;
  }, [u]);
  const d = x.useMemo(() => ({
    state: n,
    updateState: r,
    clear() {
      r({}), a(null);
    },
    terminationFees: s,
    currentOfferCost: l,
    newOfferCost: c,
    savings: m,
    completedSteps: u,
    expanded: o,
    setExpanded: a
  }), [n, s, l, c, m, u, o, a]);
  return /* @__PURE__ */ i(mt.Provider, { value: d, children: e });
}
function Ir() {
  const t = x.useContext(ft);
  if (t === null) throw new Error("useSerieFreePriceContext must be used within a SerieFreePriceContext provider");
  return t;
}
const Lr = D(M)({
  display: "flex",
  gap: 8,
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "flex-end",
  backgroundColor: "white",
  borderTop: `1px solid ${T(b[300], 0.5)}`,
  padding: "8px 8px",
  "& .MuiTextField-root": {
    flexGrow: 1,
    marginTop: 8
  },
  "& .MuiTypography-h4": {
    fontSize: 12,
    lineHeight: "16px"
  },
  "& .price-update": {
    flexShrink: 0
  },
  "& .MuiFormControl-root": {
    marginTop: 0,
    "& .MuiFormLabel-root": {
      top: -4,
      "&.MuiInputLabel-shrink": {
        top: "unset",
        backgroundColor: "transparent",
        color: b[400]
      }
    }
  }
});
function Rr() {
  const { state: t, updateState: e } = O(), { price: n, updatePrice: r } = Ir(), o = x.useMemo(() => [
    ...dr,
    { ...ur, firstYear: n },
    { ...pt, firstYear: n }
  ], [n]), a = o.filter((d) => d.__typename === "BoxPrice"), s = o.filter((d) => d.__typename === "MobilePrice"), l = t.contractType === "box" ? a : s, { strings: c, locale: m } = C(), u = new Intl.NumberFormat(m, { style: "currency", currency: "EUR" });
  function p(d) {
    return `${d.name} (${u.format(d.firstYear)}${d.secondYear ? ` / ${u.format(d.secondYear)}` : ""})`;
  }
  return /* @__PURE__ */ f(Lr, { children: [
    /* @__PURE__ */ i(
      k,
      {
        label: c.formula.offer.offerTitle,
        select: !0,
        onChange: (d) => {
          const h = d.target.value, w = l.find((v) => v.id === h);
          e((v) => ({ ...v, newOffer: w }));
        },
        defaultValue: t?.newOffer?.id ?? "",
        fullWidth: !0,
        SelectProps: {
          displayEmpty: !0,
          MenuProps: {
            anchorOrigin: { vertical: "bottom", horizontal: 2 },
            transformOrigin: { vertical: -6, horizontal: 2 }
          }
        },
        children: l.map((d) => /* @__PURE__ */ i(_e, { value: d.id, children: p(d) }, d.id))
      }
    ),
    /* @__PURE__ */ i(R, { in: t.newOffer?.id?.startsWith("serie-free"), mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ i(M, { className: "price-update", children: /* @__PURE__ */ i(
      k,
      {
        label: c.formula.offer.customizeTitle,
        type: "number",
        sx: { width: 200 },
        defaultValue: l.find((d) => d.id === "serie-free")?.firstYear ?? "",
        onChange: (d) => {
          const h = Number(d.target.value).valueOf();
          !Number.isNaN(h) && t.newOffer && (r(h), e((w) => ({
            ...w,
            newOffer: { ...w.newOffer, firstYear: h }
          })));
        },
        InputProps: {
          inputProps: { min: 0 },
          endAdornment: /* @__PURE__ */ i(g, { variant: "body1", children: "€" })
        }
      }
    ) }) })
  ] });
}
function Yr() {
  const { terminationFees: t, currentOfferCost: e } = O();
  return !t || !e ? null : /* @__PURE__ */ i(Rr, {});
}
function Br(t) {
  const { strings: e } = C(), {
    className: n,
    format: r,
    nodeKey: o
  } = t, { clear: a } = O();
  return /* @__PURE__ */ i(
    Ue,
    {
      className: n,
      format: r,
      nodeKey: o,
      children: /* @__PURE__ */ f(vr, { children: [
        /* @__PURE__ */ f(N, { className: "header", children: [
          /* @__PURE__ */ i(g, { variant: "subtitle1", children: e.formula.title }),
          /* @__PURE__ */ i(pe, { onClick: () => a(), variant: "outlined", color: "info", children: e.clear })
        ] }),
        /* @__PURE__ */ f(N, { children: [
          /* @__PURE__ */ f(N, { className: "fields", children: [
            /* @__PURE__ */ i(mr, {}),
            /* @__PURE__ */ i(Zn, {}),
            /* @__PURE__ */ i(_r, {}),
            /* @__PURE__ */ i(Cr, { children: /* @__PURE__ */ i(Yr, {}) })
          ] }),
          /* @__PURE__ */ i(yr, {})
        ] })
      ] })
    }
  );
}
function Hr(t) {
  return /* @__PURE__ */ i(Pr, { children: /* @__PURE__ */ i(Br, { ...t }) });
}
const Je = "formula-node";
function $r(t) {
  return { node: gt() };
}
class Me extends Ge {
  static getType() {
    return Je;
  }
  static clone(e) {
    return new Me(e.__format, e.__key);
  }
  static importJSON(e) {
    const n = gt();
    return n.setFormat(e.format), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: Je,
      version: 1
    };
  }
  static importDOM() {
    return {
      div: (e) => e.hasAttribute("data-lexical-card-link-id") ? {
        conversion: $r,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const e = document.createElement("div");
    return e.setAttribute("data-lexical-card-link-id", this.__id), { element: e };
  }
  getId() {
    return this.__id;
  }
  decorate(e, n) {
    const r = n.theme.embedBlock || {}, o = {
      base: r.base || "",
      focus: r.focus || ""
    };
    return /* @__PURE__ */ i(
      Hr,
      {
        className: o,
        format: this.__format,
        nodeKey: this.getKey()
      }
    );
  }
  isTopLevel() {
    return !0;
  }
}
function gt() {
  return new Me();
}
class Ne extends Pe {
  __className;
  static getType() {
    return "emoji";
  }
  static clone(e) {
    return new Ne(e.__className, e.__text, e.__key);
  }
  constructor(e, n, r) {
    super(n, r), this.__className = e;
  }
  createDOM(e) {
    const n = document.createElement("span"), r = super.createDOM(e);
    return n.className = this.__className, r.className = "emoji-inner", n.appendChild(r), n;
  }
  updateDOM(e, n, r) {
    const o = n.firstChild;
    return o === null ? !0 : (super.updateDOM(e, o, r), !1);
  }
  static importJSON(e) {
    const n = zr(
      e.className,
      e.text
    );
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(e.style), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      className: this.getClassName(),
      type: "emoji"
    };
  }
  getClassName() {
    return this.getLatest().__className;
  }
}
function zr(t, e) {
  const n = new Ne(t, e).setMode("token");
  return Y(n);
}
function Wr({ src: t, children: e }) {
  const { onImageOpen: n, strings: r } = C();
  return n ? /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      title: r.imageOpenInNewTab,
      onClick: () => {
        n(t);
      },
      style: {
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "block"
      },
      children: e
    }
  ) : e;
}
const Jr = Ke.lazy(
  // @ts-ignore
  () => import("./ImageComponent-B7cYoVIi.js")
);
function Vr(t) {
  if (t instanceof HTMLImageElement) {
    const {
      alt: e,
      src: n,
      width: r,
      height: o
    } = t;
    return { node: bt({
      altText: e,
      height: o,
      src: n,
      width: r
    }) };
  }
  return null;
}
class ae extends Z {
  __src;
  __altText;
  __width;
  __height;
  __maxWidth;
  __showCaption;
  __caption;
  // Captions cannot yet be used within editor cells
  __captionsEnabled;
  static getType() {
    return "image";
  }
  static clone(e) {
    return new ae(
      e.__src,
      e.__altText,
      e.__maxWidth,
      e.__width,
      e.__height,
      e.__showCaption,
      e.__caption,
      e.__captionsEnabled,
      e.__key
    );
  }
  static importJSON(e) {
    const {
      altText: n,
      height: r,
      width: o,
      maxWidth: a,
      caption: s,
      src: l,
      showCaption: c
    } = e, m = bt({
      altText: n,
      height: r,
      maxWidth: a,
      showCaption: c,
      src: l,
      width: o
    }), u = m.__caption, p = u.parseEditorState(s.editorState);
    return p.isEmpty() || u.setEditorState(p), m;
  }
  exportDOM() {
    const e = document.createElement("img");
    return e.setAttribute("src", this.__src), e.setAttribute("alt", this.__altText), e.setAttribute("width", this.__width.toString()), e.setAttribute("height", this.__height.toString()), { element: e };
  }
  static importDOM() {
    return {
      img: (e) => ({
        conversion: Vr,
        priority: 0
      })
    };
  }
  constructor(e, n, r, o, a, s, l, c, m) {
    super(m), this.__src = e, this.__altText = n, this.__maxWidth = r, this.__width = o || "inherit", this.__height = a || "inherit", this.__showCaption = s || !1, this.__caption = l || Jt(), this.__captionsEnabled = c || c === void 0;
  }
  exportJSON() {
    return {
      altText: this.getAltText(),
      caption: this.__caption.toJSON(),
      height: this.__height === "inherit" ? 0 : this.__height,
      maxWidth: this.__maxWidth,
      showCaption: this.__showCaption,
      src: this.getSrc(),
      type: "image",
      version: 1,
      width: this.__width === "inherit" ? 0 : this.__width
    };
  }
  setWidthAndHeight(e, n) {
    const r = this.getWritable();
    r.__width = e, r.__height = n;
  }
  setShowCaption(e) {
    const n = this.getWritable();
    n.__showCaption = e;
  }
  // View
  createDOM(e) {
    const n = document.createElement("span"), { theme: r } = e, o = r.image;
    return o !== void 0 && (n.className = o), n;
  }
  updateDOM() {
    return !1;
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  decorate() {
    return /* @__PURE__ */ i(qe, { fallback: null, children: /* @__PURE__ */ i(Wr, { src: this.__src, children: /* @__PURE__ */ i(
      Jr,
      {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth,
        nodeKey: this.getKey(),
        showCaption: this.__showCaption,
        caption: this.__caption,
        captionsEnabled: this.__captionsEnabled,
        resizable: !0
      }
    ) }) });
  }
}
function bt({
  altText: t,
  height: e,
  maxWidth: n = 500,
  captionsEnabled: r,
  src: o,
  width: a,
  showCaption: s,
  caption: l,
  key: c
}) {
  return Y(
    new ae(
      o,
      t,
      n,
      a,
      e,
      s,
      l,
      r,
      c
    )
  );
}
function Ko(t) {
  return t instanceof ae;
}
function Kr() {
  return /* @__PURE__ */ i(ve, {});
}
function qr(t) {
  return t instanceof HTMLHRElement ? { node: xt() } : null;
}
class De extends Z {
  static getType() {
    return "separator";
  }
  static clone(e) {
    return new De(e.__key);
  }
  static importJSON() {
    return xt();
  }
  static importDOM() {
    return {
      hr: (e) => ({
        conversion: qr,
        priority: 0
      })
    };
  }
  exportJSON() {
    return {
      type: "separator",
      version: 1
    };
  }
  createDOM() {
    const e = document.createElement("div"), n = "separator";
    return e.className = n, e;
  }
  updateDOM() {
    return !1;
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  decorate() {
    return /* @__PURE__ */ i(Kr, {});
  }
}
function xt(t) {
  return Y(new De(t));
}
const jr = /* @__PURE__ */ new Map(), qo = /* @__PURE__ */ new Map(), yt = '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}', _t = (t) => t === "" ? yt : `{"root":{"children":[{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":${t},"type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1}],"direction":"ltr","format":"","indent":0,"type":"root","version":1}}`, Ur = Ke.lazy(
  // @ts-ignore
  () => import("./TableComponent-C25Pi6oo.js")
);
function vt() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function L(t) {
  return {
    colSpan: 1,
    id: vt(),
    json: yt,
    type: t,
    width: null
  };
}
function X() {
  return {
    cells: [],
    height: null,
    id: vt()
  };
}
function jo(t) {
  const e = t.querySelectorAll("tr"), n = [];
  for (let r = 0; r < e.length; r++) {
    const a = e[r].querySelectorAll("td,th");
    if (!a || a.length === 0)
      continue;
    const s = [];
    for (let c = 0; c < a.length; c++) {
      const m = a[c], u = m.nodeName === "TH", p = L(u ? "header" : "normal");
      p.json = _t(
        JSON.stringify(m.innerText.replace(/\n/g, " "))
      ), s.push(p);
    }
    const l = X();
    l.cells = s, n.push(l);
  }
  return n;
}
function Gr(t) {
  const e = t.querySelectorAll("tr");
  if (!e || e.length === 0)
    return null;
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const a = e[r].querySelectorAll("td,th");
    if (!a || a.length === 0)
      continue;
    const s = [];
    for (let c = 0; c < a.length; c++) {
      const m = a[c], u = m.nodeName === "TH", p = L(u ? "header" : "normal");
      p.json = _t(
        JSON.stringify(m.innerText.replace(/\n/g, " "))
      ), s.push(p);
    }
    const l = X();
    l.cells = s, n.push(l);
  }
  return { node: Ct(n) };
}
function Xr(t, e) {
  const n = document.createElement("table"), r = document.createElement("colgroup"), o = document.createElement("tbody"), a = t[0];
  for (let s = e != null ? e.startX : 0; s < (e != null ? e.endX + 1 : a.cells.length); s++) {
    const l = document.createElement("col");
    r.append(l);
  }
  for (let s = e != null ? e.startY : 0; s < (e != null ? e.endY + 1 : t.length); s++) {
    const l = t[s], { cells: c } = l, m = document.createElement("tr");
    for (let u = e != null ? e.startX : 0; u < (e != null ? e.endX + 1 : c.length); u++) {
      const p = c[u], d = document.createElement(
        p.type === "header" ? "th" : "td"
      );
      d.innerHTML = jr.get(p.json) || "", m.appendChild(d);
    }
    o.appendChild(m);
  }
  return n.appendChild(r), n.appendChild(o), n;
}
class K extends Z {
  __rows;
  static getType() {
    return "tablesheet";
  }
  static clone(e) {
    return new K(Array.from(e.__rows), e.__key);
  }
  static importJSON(e) {
    return Ct(e.rows);
  }
  exportJSON() {
    return {
      rows: this.__rows,
      type: "tablesheet",
      version: 1
    };
  }
  static importDOM() {
    return {
      table: (e) => ({
        conversion: Gr,
        priority: 0
      })
    };
  }
  exportDOM() {
    return { element: Xr(this.__rows) };
  }
  constructor(e, n) {
    super(n), this.__rows = e || [];
  }
  createDOM() {
    return document.createElement("div");
  }
  updateDOM() {
    return !1;
  }
  mergeRows(e, n, r) {
    const a = this.getWritable().__rows, s = Math.min(a.length, n + r.length);
    for (let l = n; l < s; l++) {
      const c = a[l], m = r[l - n], { cells: u } = c, p = Array.from(u), d = { ...c, cells: p }, h = m.cells, w = Math.min(u.length, e + h.length);
      for (let v = e; v < w; v++) {
        const q = u[v], S = h[v - e], j = { ...q, json: S.json, type: S.type };
        p[v] = j;
      }
      a[l] = d;
    }
  }
  updateCellJSON(e, n, r) {
    const a = this.getWritable().__rows, s = a[n], { cells: l } = s, c = l[e], m = Array.from(l), u = { ...c, json: r }, p = { ...s, cells: m };
    m[e] = u, a[n] = p;
  }
  updateCellType(e, n, r) {
    const a = this.getWritable().__rows, s = a[n], { cells: l } = s, c = l[e], m = Array.from(l), u = { ...c, type: r }, p = { ...s, cells: m };
    m[e] = u, a[n] = p;
  }
  insertColumnAt(e) {
    const r = this.getWritable().__rows;
    for (let o = 0; o < r.length; o++) {
      const a = r[o], { cells: s } = a, l = Array.from(s), c = { ...a, cells: l }, { type: m } = s[e] || s[e - 1];
      l.splice(e, 0, L(m)), r[o] = c;
    }
  }
  deleteColumnAt(e) {
    const r = this.getWritable().__rows;
    for (let o = 0; o < r.length; o++) {
      const a = r[o], { cells: s } = a, l = Array.from(s), c = { ...a, cells: l };
      l.splice(e, 1), r[o] = c;
    }
  }
  addColumns(e) {
    const r = this.getWritable().__rows;
    for (let o = 0; o < r.length; o++) {
      const a = r[o], { cells: s } = a, l = Array.from(s), c = { ...a, cells: l }, { type: m } = s[s.length - 1];
      for (let u = 0; u < e; u++)
        l.push(L(m));
      r[o] = c;
    }
  }
  insertRowAt(e) {
    const r = this.getWritable().__rows, o = r[e] || r[e - 1], a = o.cells.length, s = X();
    for (let l = 0; l < a; l++) {
      const c = L(o.cells[l].type);
      s.cells.push(c);
    }
    r.splice(e, 0, s);
  }
  deleteRowAt(e) {
    this.getWritable().__rows.splice(e, 1);
  }
  addRows(e) {
    const r = this.getWritable().__rows, o = r[r.length - 1], a = o.cells.length;
    for (let s = 0; s < e; s++) {
      const l = X();
      for (let c = 0; c < a; c++) {
        const m = L(o.cells[c].type);
        l.cells.push(m);
      }
      r.push(l);
    }
  }
  updateColumnWidth(e, n) {
    const o = this.getWritable().__rows;
    for (let a = 0; a < o.length; a++) {
      const s = o[a], { cells: l } = s, c = Array.from(l), m = { ...s, cells: c };
      c[e].width = n, o[a] = m;
    }
  }
  decorate(e, n) {
    return /* @__PURE__ */ i(qe, { children: /* @__PURE__ */ i(
      Ur,
      {
        nodeKey: this.__key,
        theme: n.theme,
        rows: this.__rows
      }
    ) });
  }
  isInline() {
    return !1;
  }
}
function Uo(t) {
  return t instanceof K;
}
function Ct(t) {
  return new K(t);
}
function Go(t, e, n = !0) {
  const r = [];
  for (let o = 0; o < e; o++) {
    const a = X();
    r.push(a);
    for (let s = 0; s < t; s++)
      a.cells.push(
        L(
          n === !0 && (o === 0 || s === 0) ? "header" : "normal"
        )
      );
  }
  return new K(r);
}
class xe extends Q {
  __id;
  static getType() {
    return "youtube";
  }
  static clone(e) {
    return new xe(e.__id, e.__key);
  }
  static importJSON(e) {
    return new xe(e.videoID);
  }
  // Export the node to JSON format for storage or transmission
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "youtube",
      videoID: this.__id
    };
  }
  constructor(e, n) {
    super(n), this.__id = e;
  }
  createDOM() {
    const e = document.createElement("iframe");
    return e.setAttribute("data-lexical-youtube", this.__id), e.setAttribute("width", "560"), e.setAttribute("height", "315"), e.setAttribute(
      "src",
      `https://www.youtube-nocookie.com/embed/${this.__id}`
    ), e.setAttribute("frameborder", "0"), e.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    ), e.setAttribute("allowfullscreen", "true"), e.setAttribute("title", "YouTube video"), e;
  }
  updateDOM() {
    return !1;
  }
  getId() {
    return this.__id;
  }
  getTextContent() {
    return `https://www.youtube.com/watch?v=${this.__id}`;
  }
}
const Xo = [
  At,
  Ot,
  St,
  Pt,
  Ft,
  K,
  It,
  Lt,
  Rt,
  Nt,
  Mt,
  Dt,
  Et,
  Tt,
  ae,
  Ne,
  kt,
  te,
  ne,
  re,
  oe,
  ee,
  ie,
  we,
  Ce,
  Me,
  Fe,
  De,
  xe
];
export {
  bt as $,
  re as A,
  ne as B,
  Ze as C,
  In as D,
  Ne as E,
  Wo as F,
  Rn as G,
  ct as H,
  ae as I,
  st as J,
  lt as K,
  Tn as L,
  Me as M,
  gt as N,
  Dn as O,
  Xo as P,
  ee as Q,
  zo as R,
  at as S,
  Fn as T,
  oe as U,
  Jo as V,
  $o as W,
  ut as X,
  ie as Y,
  dt as Z,
  Vo as _,
  I as a,
  Un as a0,
  zr as a1,
  qo as a2,
  Uo as a3,
  jo as a4,
  jr as a5,
  Xr as a6,
  X as a7,
  vt as a8,
  K as a9,
  Go as aa,
  To as b,
  E as c,
  ke as d,
  Oo as e,
  Yo as f,
  Bo as g,
  ko as h,
  C as i,
  Ho as j,
  F as k,
  ge as l,
  k as m,
  Ao as n,
  Ro as o,
  $e as p,
  Ae as q,
  Io as r,
  b as s,
  Po as t,
  y as u,
  Lo as v,
  So as w,
  Ko as x,
  En as y,
  te as z
};
//# sourceMappingURL=PlaygroundNodes-B1J2GgG-.js.map
